import { tokens } from './tokens';

const translations: Record<string, string> = {
  [tokens.platform.teams.manager.title]: 'Teams',
  [tokens.platform.teams.add_organization.title]: 'Add organization',
  [tokens.platform.teams.organization.start.title]: 'Start an Organization',
  [tokens.platform.teams.organization.start.description]: 'Create your organization and invite new users to join by sending them an email invitation.',
  [tokens.platform.teams.organization.nameInput]: 'Organization Name',
  [tokens.platform.teams.plan]: '{{currentPlan}} Plan',
  [tokens.onboarding.organization.title]: 'Start an Organization',
  [tokens.onboarding.organization.description]: 'Choose a name for your organization and invite members to join it.',
  [tokens.onboarding.organization_pricing.features.questions]: '{{count}} questions',
  [tokens.onboarding.organization_pricing.features.pages]: '{{count}} pages',
  [tokens.onboarding.organization_pricing.features.minutes]: '{{count}} minutes',
  [tokens.onboarding.organization_pricing.features.users]: 'Up to {{count}} user',
  [tokens.onboarding.organization_pricing.features.users_other]: 'Up to {{count}} users',
  [tokens.onboarding.organization_pricing.features.multi_provider]: 'Multi provider',
  [tokens.onboarding.organization_pricing.features.dedicated_support]: 'Dedicated support',
  [tokens.onboarding.organization_pricing.features.priority_queues]: 'Priority in queues',
  [tokens.onboarding.organization_pricing.features.low_priority]: 'Low priority in queues',
  [tokens.onboarding.organization_pricing.features.slack_support]: 'Slack support',
  [tokens.onboarding.organization_pricing.features.high_question_limit]: 'High question limit',
  [tokens.onboarding.organization_pricing.features.unlimited_pages]: 'Unlimited pages',
  [tokens.onboarding.organization_pricing.features.unlimited_minutes]: 'Unlimited minutes',
  [tokens.onboarding.organization_pricing.features.unlimited_users]: 'Unlimited users',
  [tokens.onboarding.organization_pricing.features.advanced_multi_provider]: 'Advanced multi provider',
  [tokens.onboarding.organization_pricing.features.separate_tenant]: 'Separate tenant',
  [tokens.onboarding.organization_pricing.features.sso]: 'SSO',
  [tokens.onboarding.organization_pricing.features.guaranteed_sla]: 'Guaranteed SLA',
  [tokens.onboarding.organization_pricing.features.security_report]: 'Security report',
  [tokens.onboarding.organization_pricing.features.xlsx_import]: 'XLSX import',
  [tokens.onboarding.organization_pricing.tooltips.questions]: 'Number of monthly questions you can ask',
  [tokens.onboarding.organization_pricing.tooltips.pages]: 'Number of pages that can be indexed',
  [tokens.onboarding.organization_pricing.tooltips.minutes]: 'Monthly processing time',
  [tokens.onboarding.organization_pricing.tooltips.multi_provider]: 'Ability to connect to multiple AI providers',
  [tokens.onboarding.organization_pricing.tooltips.low_priority]: 'Lower priority in the support queue',
  [tokens.onboarding.organization_pricing.tooltips.slack_support]: 'Support available via Slack',
  [tokens.onboarding.organization_pricing.tooltips.sso]: 'Single Sign-On for corporate authentication',
  [tokens.onboarding.organization_pricing.tooltips.high_question_limit]: 'Custom limit based on your needs',
  [tokens.onboarding.organization_pricing.plans.description.individual_users]: 'For individual users',
  [tokens.onboarding.organization_pricing.plans.description.growing_teams]: 'For growing teams',
  [tokens.onboarding.organization_pricing.plans.description.large_organizations]: 'For large organizations',
  [tokens.onboarding.organization_pricing.upgrade_plan]: 'Upgrade Your Plan',
  [tokens.onboarding.organization_pricing.choose_plan_for_organization]: 'Choose a plan for your organization',
  [tokens.onboarding.organization_pricing.current_plan_message]: 'You\'re currently on the {{currentPlan}} plan. Explore our other plans to find the one that best fits your growing needs.',
  [tokens.onboarding.organization_pricing.congratulations_choose_plan]: 'Congratulations on creating your organization! Now choose the ideal plan for your needs.',
  [tokens.onboarding.organization_pricing.continue_with_plan]: 'Continue with {{currentPlan}}',
  [tokens.onboarding.organization_pricing.subscribe_now]: 'Subscribe Now',
  [tokens.onboarding.organization_pricing.contact_sales]: 'Contact sales',
  [tokens.onboarding.organization_pricing.month]: 'Month',
  [tokens.onboarding.organization_pricing.custom]: 'Custom',
  [tokens.onboarding.organization_pricing.contact_sales]: 'Contact sales',
  [tokens.onboarding.organization_pricing.most_popular]: 'Most Popular',
  [tokens.onboarding.organization_pricing.contact_sales_modal.upgrade_to_enterprise]: 'Upgrade to Enterprise',
  [tokens.onboarding.organization_pricing.contact_sales_modal.submit_request]: 'Submit your request to evaluate migration to the Enterprise plan.',
  [tokens.onboarding.organization_pricing.contact_sales_modal.my_email]: 'My email',
  [tokens.onboarding.organization_pricing.contact_sales_modal.subject]: 'Subject',
  [tokens.onboarding.organization_pricing.contact_sales_modal.describe_needs]: 'Describe your specific needs',
  [tokens.onboarding.organization_pricing.contact_sales_modal.send_request]: 'Send request',
  [tokens.onboarding.organization_pricing.contact_sales_modal.additional_message]: 'Additional message (optional)',
  [tokens.onboarding.organization_pricing.contact_sales_modal.request_to_upgrade_placeholder]: 'Upgrade to Enterprise plan',
  [tokens.onboarding.organization_pricing.contact_sales_modal.request_submitted]: 'Request Submitted!',
  [tokens.onboarding.organization_pricing.contact_sales_modal.sales_team_contact]: 'Our sales team will contact you shortly to discuss your enterprise needs.',
  [tokens.onboarding.organization_pricing.contact_sales_modal.whats_next]: 'What\'s next?',
  [tokens.onboarding.organization_pricing.contact_sales_modal.continue_with_community_plan]: 'You can continue with the Community plan while we review your request. We\'ll upgrade your account manually once your enterprise plan is approved.',
  [tokens.onboarding.organization_pricing.contact_sales_modal.continue_with_current_plan]: 'Continue with current plan',
  [tokens.onboarding.organization_pricing.features.max_mb_docs]: '{{count}} MB for documents',
  [tokens.onboarding.organization_pricing.features.max_mb_spreadsheets]: '{{count}} MB for spreadsheets',
  [tokens.onboarding.organization_pricing.features.max_mb_translator]: '{{count}} MB/month for translation',
  [tokens.onboarding.organization_pricing.tooltips.max_mb_docs]: 'Storage limit for documents',
  [tokens.onboarding.organization_pricing.tooltips.max_mb_spreadsheets]: 'Storage limit for spreadsheets',
  [tokens.onboarding.organization_pricing.tooltips.max_mb_translator]: 'Monthly translation processing volume (resets each month)',
  [tokens.dashboard.title]: 'Statistics Panel',
  [tokens.dashboard.tab.overview]: 'Overview',
  [tokens.dashboard.tab.analytics]: 'Analytics',
  [tokens.dashboard.metric.questionsAnswered]: 'Questions asked',
  [tokens.dashboard.metric.metricPeriod.description]: 'In selected period',
  [tokens.dashboard.metric.files]: 'Processed files',
  [tokens.dashboard.metric.invitedUsers.title]: 'Invited users',
  [tokens.dashboard.metric.invitedUsers.description]: 'Total invited users',
  [tokens.dashboard.metric.groups.title]: 'Groups',
  [tokens.dashboard.metric.groups.description]: 'Active groups',
  [tokens.dashboard.graph.title]: 'Overview',
  [tokens.dashboard.graph.subtitle]: 'Based on the selected period',
  [tokens.dashboard.graph.totalTooltip]: 'Total',
  [tokens.dashboard.graph.noInteractionData]: 'No interaction data available for the selected period',
  [tokens.dashboard.chatHistoryTable.questionColumn]: 'Question',
  [tokens.dashboard.chatHistoryTable.numberOfMessagesColumn]: 'Number of Messages',
  [tokens.dashboard.chatHistoryTable.dateColumn]: 'Date',
  [tokens.dashboard.chatHistoryTable.askedBy]: 'Asked by',
  [tokens.dashboard.chatHistoryTable.title]: 'Interaction Control',
  [tokens.dashboard.chatHistoryTable.description]: 'Track the details of interactions made via assistant and workstation',
  [tokens.dashboard.chatHistoryTable.questionFilter.placeholder]: 'Search by first question...',
  [tokens.dashboard.chatHistoryTable.modal.title]: 'Chat history',
  [tokens.dashboard.chatHistoryTable.noChatsFound]: 'No chats found',
  [tokens.dashboard.chatHistoryTable.loadingChatHistory]: 'Loading Chat History',
  [tokens.dashboard.chatHistoryTable.deleteDialogTitle]: 'Are you sure you want to delete this chat?',
  [tokens.dashboard.chatHistoryTable.deleteDialogDescription]: 'This action cannot be undone.',
  [tokens.workstation.title]: 'Workstation',
  [tokens.workstation.subtitle]: 'Talk to Alan and have an amazing experience.',
  [tokens.workstation.welcome]: 'Welcome to Workstation',
  [tokens.workstation.welcomeSubtitle]: 'Start a conversation and explore topics with Alan, our AI assistant.',
  [tokens.workstation.prompt.placeholder]: 'Ask Alan your question',
  [tokens.workstation.newchat]: 'New chat',
  [tokens.workstation.sources.title]: 'Sources',
  [tokens.workstation.sources.empty]: 'Start a conversation to see results here.',
  [tokens.workstation.sources.search_results]: 'Search Results',
  [tokens.workstation.sources.relevance]: 'Relevance',
  [tokens.workstation.sources.previous]: 'Previous',
  [tokens.workstation.sources.segmentTimestamps]: 'Video Segments',
  [tokens.workstation.sources.videoStart]: 'Start',
  [tokens.workstation.sources.videoEnd]: 'End',
  [tokens.workstation.sources.next]: 'Next',
  [tokens.workstation.sources.passage_in_documents]: '{{count}} passage in documents',
  [tokens.workstation.sources.passage_in_documents_plural]: '{{count}} passages in documents',
  [tokens.workstation.sources.goToSource]: 'Go to source',
  [tokens.workstation.reasoning.title]: 'Reasoning',
  [tokens.workstation.folders.label]: 'Folders',
  [tokens.workstation.folders.empty]: 'No folders available',
  [tokens.workstation.folders.all_knowledge]: 'Entire knowledge base',
  [tokens.workstation.folders.searchFolders]: 'Search folders',
  [tokens.workstation.folders.selectAllFolders]: 'Select all',
  [tokens.workstation.folders.deselectAllFolders]: 'Deselect all',
  [tokens.workstation.folders.noResults]: 'No folders found',
  [tokens.workstation.tools.title]: 'Tools',
  [tokens.workstation.tools.externalSearch]: 'Web Search',
  [tokens.workstation.tools.deepSearch]: 'Deep Search',
  [tokens.tokens.workstation.reasoning.process_steps]: 'Reasoning process',
  [tokens.workstation.reasoning.tools.planner]: 'Building an execution plan',
  [tokens.workstation.reasoning.tools.userFiles]: 'Looking for your files',
  [tokens.workstation.reasoning.tools.pageSearch]: 'Searching information in your documents',
  [tokens.workstation.reasoning.tools.documentSearch]: 'Searching in your document summary',
  [tokens.workstation.reasoning.tools.userFolders]: 'Looking in your folders',
  [tokens.workstation.reasoning.tools.videoSearch]: 'Searching in your videos',
  [tokens.workstation.sources.errorLoadingVideo]: 'Error loading video',
  [tokens.workstation.sources.tryAgain]: 'Try again',
  [tokens.workstation.reasoning.tools.contentGenerator]: 'Generating content',
  [tokens.workstation.reasoning.tools.queryGeneration]: 'Generating a query',
  [tokens.workstation.reasoning.tools.database]: 'Querying the database',
  [tokens.workstation.reasoning.tools.externalSearchTool]: 'Searching the web',
  [tokens.workstation.reasoning.tools.chatHistory]: 'Searching chat history',
  [tokens.workstation.reasoning.tools.terminal]: 'Running terminal commands',
  [tokens.workstation.reasoning.tools.analytics]: 'Analyzing data',
  [tokens.workstation.reasoning.tools.unifiedSearch]: 'Searching information in your documents',
  [tokens.tokens.workstation.reasoning.tools.generic]: 'Using a tool',
  [tokens.workstation.loadingSuggestions]: 'Loading suggestions...',
  [tokens.workstation.start_with_suggested_question]: 'Start with a suggested question:',
  [tokens.workstation.sources.show_message]: 'Show message',
  [tokens.workstation.message.file_search_results]: 'Results from file search',
  [tokens.workstation.message.web_search_results]: 'Web search results',
  [tokens.workstation.messages.me]: 'Me',
  [tokens.workstation.memory.title]: 'Memory',
  [tokens.workstation.memory.subtitle]: 'Managing saved memories during your conversations',
  [tokens.workstation.history.title]: 'History',
  [tokens.workstation.history.subtitle]: 'Manage your conversation history and pick up where you left off.',
  [tokens.workstation.report.columns.chat_id]: 'Chat ID',
  [tokens.workstation.report.columns.user_message]: 'User message',
  [tokens.workstation.report.columns.assistant_message]: 'Assistant message',
  [tokens.workstation.report.columns.created_at]: 'Created At',
  [tokens.workstation.report.columns.username]: 'Username',
  [tokens.workstation.report.columns.user_email]: 'User email',
  [tokens.workstation.report.download]: 'Download',
  [tokens.workstation.report.downloading]: 'Downloading',
  [tokens.workstation.report.truncatedContent]: '[... content truncated ...]',
  [tokens.workstation.report.toasts.reportStartGeneration.title]: 'We are generating your report...',
  [tokens.workstation.report.toasts.reportStartGeneration.description]: 'Please wait while we process the selected data.',
  [tokens.workstation.report.toasts.reportSuccessfulGeneration.title]: 'Report generated successfully!',
  [tokens.workstation.report.toasts.reportSuccessfulGeneration.description]: 'The download of the file will begin shortly.',
  [tokens.workstation.report.toasts.noDataReportGeneration.title]: 'No data found',
  [tokens.workstation.report.toasts.noDataReportGeneration.description]: 'There are no interactions available for the selected period.',
  [tokens.workstation.report.toasts.errorOnReportGeneration.title]: 'Error generating report',
  [tokens.workstation.report.toasts.errorOnReportGeneration.description]: 'There was an issue generating the report. Please try again later.',
  [tokens.agent.executions.errors.startExecution]: 'Error starting execution',
  [tokens.agent.executions.errors.continueExecution]: 'Error continuing execution',
  [tokens.agent.executions.errors.fetchReview]: 'Error fetching review',
  [tokens.agent.executions.errors.fetchReviewDescription]: 'Could not load the review.',
  [tokens.agent.executions.review.noPendingReviews]: 'No pending reviews',
  [tokens.agent.executions.review.noPendingReviewsDescription]: 'There are no pending reviews for this execution.',
  [tokens.agent.executions.review.notFound]: 'Review not found',
  [tokens.agent.executions.review.notFoundDescription]: 'Could not find the corresponding review.',
  [tokens.agent.access.editAccess]: 'Edit Access',
  [tokens.agent.access.allowedGroups]: 'Allowed Groups',
  [tokens.agent.access.allowedUsers]: 'Allowed Users',
  [tokens.agent.access.selectGroups]: 'Select Groups',
  [tokens.agent.access.selectUsers]: 'Select Users',
  [tokens.ui.toasts.agent.update_error.title]: 'Error updating agent',
  [tokens.ui.toasts.agent.update_error.description]: 'An error occurred while updating the agent',
  [tokens.aihub.createAgent.error.title]: 'Error creating agent',
  [tokens.aihub.createAgent.error.description]: 'Could not create the agent',
  [tokens.aihub.createAssistant.error.title]: 'Error creating assistant',
  [tokens.aihub.createAssistant.error.description]: 'Could not create the assistant',
  [tokens.agent.title]: 'Agent',
  [tokens.agent.subtitle]: 'Here is a list of your agents to manage them!',
  [tokens.agent.newAgent]: 'New agent',
  [tokens.agent.notFound]: 'No agents found',
  [tokens.agent.search.agents]: 'Search agents...',
  [tokens.agent.label.dataInput]: 'Data Input',
  [tokens.agent.label.processing]: 'Processing',
  [tokens.agent.label.dataOutput]: 'Data Output',
  [tokens.agent.label.howToUse]: 'How to use: Drag components onto the canvas to create your workflow.',
  [tokens.agent.label.label]: 'Label',
  [tokens.agent.label.format]: 'Format',
  [tokens.agent.label.compareDocuments]: 'Compare Documents',
  [tokens.agent.label.folderSelection]: 'Folder Selection',
  [tokens.agent.label.fileFilters]: 'File Filters',
  [tokens.agent.label.addFilter]: 'Add Filter',
  [tokens.agent.label.startsWith]: 'Starts With',
  [tokens.agent.label.endsWith]: 'Ends With',
  [tokens.agent.label.contains]: 'Contains',
  [tokens.agent.label.extensions]: 'Extensions',
  [tokens.agent.label.selectExtensions]: 'Select Extensions',
  [tokens.agent.label.filePreview]: 'File Preview',
  [tokens.agent.label.rules]: 'Rules',
  [tokens.agent.label.newRule]: 'New Rule',
  [tokens.agent.label.outputFormat]: 'Output Format',
  [tokens.agent.label.generatePDF]: 'Generate PDF',
  [tokens.agent.executions.selectAgent]: 'Select an agent to view its executions',
  [tokens.agent.executions.loading]: 'Loading executions...',
  [tokens.agent.executions.noExecutionsFound]: 'No executions found.',
  [tokens.agent.executions.columns.executionDate]: 'Execution Date',
  [tokens.agent.executions.columns.status]: 'Status',
  [tokens.agent.executions.status.completed]: 'Completed',
  [tokens.agent.executions.status.failed]: 'Failed',
  [tokens.agent.executions.pagination.pageOf]: 'Page {{current}} of {{total}}',
  [tokens.agent.executions.pagination.firstPage]: 'First page',
  [tokens.agent.executions.pagination.previousPage]: 'Previous page',
  [tokens.agent.executions.pagination.nextPage]: 'Next page',
  [tokens.agent.executions.pagination.lastPage]: 'Last page',
  [tokens.agent.editor.ner.title]: 'Entity Recognition',
  [tokens.agent.editor.ner.description]: 'Configure the entities that should be identified in the text',
  [tokens.agent.editor.ner.addEntity.label]: 'Add Entity',
  [tokens.agent.editor.ner.addEntity.namePlaceholder]: 'Entity name ex: Person, Company',
  [tokens.agent.editor.ner.addEntity.descriptionPlaceholder]: 'Entity description ex: Names of natural persons',
  [tokens.agent.editor.ner.addEntity.examples.label]: 'Examples',
  [tokens.agent.editor.ner.addEntity.examples.placeholder]: 'Entity example ex: João Silva, Maria Santos',
  [tokens.agent.editor.ner.addEntity.button]: 'Add Entity',
  [tokens.agent.editor.ner.entities.label]: 'Entities ({{count}} of {{total}})',
  [tokens.agent.editor.ner.entities.searchPlaceholder]: 'Search entities by name, description or examples...',
  [tokens.agent.editor.ner.entities.examplesButton]: 'Examples ({{count}})',
  [tokens.agent.editor.ner.entities.emptyState]: 'No entities configured',
  [tokens.agent.editor.ner.entities.noResultsFound]: 'No entities found for "{{searchTerm}}"',
  [tokens.agent.editor.ner.entities.clearSearch]: 'Clear search',
  [tokens.agent.editor.ner.editEntity.namePlaceholder]: 'Entity name',
  [tokens.agent.editor.ner.editEntity.descriptionPlaceholder]: 'Entity description',
  [tokens.agent.editor.ner.editEntity.examples.label]: 'Examples',
  [tokens.agent.editor.ner.editEntity.examples.placeholder]: 'Entity example ex: João Silva, Maria Santos',
  [tokens.agent.editor.ner.editEntity.saveButton]: 'Save',
  [tokens.agent.editor.ner.editEntity.cancelButton]: 'Cancel',
  [tokens.agent.editor.ner.addEntity.examples.addButton]: 'Add example',
  [tokens.agent.newAgent]: 'New agent',
  [tokens.agent.validation.messages.nerNodeNeedsEntities]: '{{nodeName}} needs to have at least one entity configured',
  [tokens.agent.nodes.ner.name]: 'Entity Extraction',
  [tokens.agent.nodes.ner.description]: 'Identifies and extracts named entities from text',
  [tokens.agent.editor.flowComponents]: 'Flow Components',
  [tokens.agent.editor.nodes.input]: 'Input',
  [tokens.agent.editor.nodes.processing]: 'Processing',
  [tokens.agent.editor.nodes.output]: 'Output',
  [tokens.agent.editor.tabs.editor]: 'Editor',
  [tokens.agent.editor.tabs.executions]: 'Executions',
  [tokens.agent.editor.agentExecutions]: 'Agent Executions',
  [tokens.agent.editor.editConnection]: 'Edit Connection',
  [tokens.agent.editor.connection.from]: 'From',
  [tokens.agent.editor.connection.to]: 'To',
  [tokens.agent.editor.recordAudio.confirmDialog.stopCurrentRecordingDescription]: 'A recording is in progress. Do you want to stop the recording in its current state and proceed?',
  [tokens.agent.editor.recordAudio.confirmDialog.stopCurrentRecordingTip]: 'Tip: You can keep using the platform in a new tab.',
  [tokens.agent.nodes.crawlerInput.name]: 'Web Crawler Input',
  [tokens.agent.nodes.crawlerInput.description]: 'Navigates and extracts data from web pages using specific instructions',
  [tokens.agent.editor.crawlerInput.instructions]: 'Navigation Instructions',
  [tokens.agent.editor.crawlerInput.instructionsTooltip]: 'Specific instructions to guide the crawler in navigating and extracting data from web pages',
  [tokens.agent.editor.crawlerInput.instructionPlaceholder]: 'Ex: Extract all news headlines from the homepage...',
  [tokens.agent.editor.crawlerInput.urls]: 'Initial URLs',
  [tokens.agent.editor.crawlerInput.urlsTooltip]: 'Optional URLs to start navigation from. If not provided, the crawler will start according to instructions',
  [tokens.agent.editor.crawlerInput.maxPages]: 'Maximum Pages',
  [tokens.agent.editor.crawlerInput.saveFiles]: 'Save Files',
  [tokens.agent.editor.crawlerInput.saveFilesTooltip]: 'Saves extracted files to the selected folder during crawler execution',
  [tokens.agent.editor.crawlerInput.outputType]: 'Output Type',
  [tokens.agent.editor.crawlerInput.outputTypeTooltipTitle]: 'Output Type:',
  [tokens.agent.editor.crawlerInput.outputTypeDetailed]: 'Detailed',
  [tokens.agent.editor.crawlerInput.outputTypeSummary]: 'Summary',
  [tokens.agent.editor.crawlerInput.outputTypeDetailedDescription]: 'Each page will be processed and returned as a document',
  [tokens.agent.editor.crawlerInput.outputTypeSummaryDescription]: 'The result will be consolidated into a single text output',
  [tokens.agent.validation.messages.crawlerInputInstructionsRequired]: '{{nodeName}} needs to have at least one instruction defined',
  [tokens.agent.validation.messages.crawlerInputEmptyInstructions]: '{{nodeName}} cannot have empty instructions',
  [tokens.agent.validation.messages.crawlerInputInvalidUrls]: '{{nodeName}} contains invalid URLs',
  [tokens.agent.validation.messages.crawlerInputFolderRequired]: '{{nodeName}} needs to have a folder selected when \'Save Files\' is enabled',
  [tokens.agent.validation.messages.crawlerInputMaxPagesRange]: '{{nodeName}} must have between 1 and 100 maximum pages',
  [tokens.agent.scheduler.selectDays]: 'Select days',
  [tokens.agent.scheduler.weekDays.sunday]: 'Sunday',
  [tokens.agent.scheduler.weekDays.monday]: 'Monday',
  [tokens.agent.scheduler.weekDays.tuesday]: 'Tuesday',
  [tokens.agent.scheduler.weekDays.wednesday]: 'Wednesday',
  [tokens.agent.scheduler.weekDays.thursday]: 'Thursday',
  [tokens.agent.scheduler.weekDays.friday]: 'Friday',
  [tokens.agent.scheduler.weekDays.saturday]: 'Saturday',
  [tokens.agent.scheduler.scheduleExecution]: 'Schedule execution',
  [tokens.agent.scheduler.title]: 'Schedule Execution',
  [tokens.agent.scheduler.dateAndTime]: 'Date and time',
  [tokens.agent.scheduler.selectDateAndTime]: 'Select a date and time',
  [tokens.agent.scheduler.recurring]: 'Recurring',
  [tokens.agent.scheduler.repeatEvery]: 'Repeat every',
  [tokens.agent.scheduler.select]: 'Select',
  [tokens.agent.scheduler.intervals.minute]: 'Minute',
  [tokens.agent.scheduler.intervals.hour]: 'Hour',
  [tokens.agent.scheduler.intervals.day]: 'Day',
  [tokens.agent.scheduler.intervals.week]: 'Week',
  [tokens.agent.scheduler.intervals.month]: 'Month',
  [tokens.agent.scheduler.intervals.year]: 'Year',
  [tokens.agent.scheduler.daysOfWeek]: 'Days of the week',
  [tokens.agent.scheduler.ends]: 'Ends',
  [tokens.agent.scheduler.endConditions.never]: 'Never',
  [tokens.agent.scheduler.endConditions.onDate]: 'On a date',
  [tokens.agent.scheduler.endConditions.afterOccurrences]: 'After a number of occurrences',
  [tokens.agent.scheduler.endDate]: 'End date',
  [tokens.agent.scheduler.selectDate]: 'Select a date',
  [tokens.agent.scheduler.numberOfOccurrences]: 'Number of occurrences',
  [tokens.agent.scheduler.errors.loadSchedule.title]: 'Error loading schedule',
  [tokens.agent.scheduler.errors.loadSchedule.description ]: 'Could not load existing schedule',
  [tokens.agent.scheduler.errors.scheduleExecution.title]: 'Error scheduling execution',
  [tokens.agent.scheduler.errors.scheduleExecution.description]: 'An error occurred while scheduling the agent execution',
  [tokens.agent.scheduler.success.scheduleCreated.title]: 'Schedule created',
  [tokens.agent.scheduler.success.scheduleCreated.description]: 'The agent will be executed as scheduled',
  [tokens.agent.list.errors.loadAgents.title]: 'Error loading agents',
  [tokens.agent.list.errors.loadAgents.description]: 'Please try again later.',
  [tokens.agent.list.errors.deleteAgent.title]: 'Error deleting agent',
  [tokens.agent.list.errors.deleteAgent.description]: 'Please try again later.',
  [tokens.agent.list.errors.createAgent.title]: 'Error creating agent',
  [tokens.agent.list.errors.createAgent.description]: 'Please try again later.',
  [tokens.agent.list.success.agentActivated.title]: 'Agent activated',
  [tokens.agent.list.success.agentActivated.description]: 'The agent has been successfully activated.',
  [tokens.agent.list.success.agentDeactivated.title]: 'Agent deactivated',
  [tokens.agent.list.success.agentDeactivated.description]: 'The agent has been successfully deactivated.',
  [tokens.agent.list.status.all]: 'All',
  [tokens.agent.list.status.active]: 'Active',
  [tokens.agent.list.status.inactive]: 'Inactive',
  [tokens.agent.list.workingStatus.working]: 'Working',
  [tokens.agent.list.workingStatus.inactive]: 'Inactive',
  [tokens.agent.list.dialog.activateAgent.title]: 'Activate Agent',
  [tokens.agent.list.dialog.activateAgent.description]: 'Are you sure you want to activate this agent? It will start processing tasks automatically.',
  [tokens.agent.list.dialog.activateAgent.confirmText]: 'Activate',
  [tokens.agent.list.dialog.deactivateAgent.title]: 'Deactivate Agent',
  [tokens.agent.list.dialog.deactivateAgent.description]: 'Are you sure you want to deactivate this agent? It will stop processing tasks automatically.',
  [tokens.agent.list.dialog.deactivateAgent.confirmText]: 'Deactivate',
  [tokens.agent.list.success.agentScheduledImmediate ]: 'The agent was executed immediately',
  [tokens.agent.list.success.agentScheduled.title]: 'Agent scheduled successfully',
  [tokens.agent.list.success.agentScheduled.description]: 'The agent will be activated at the scheduled time',
  [tokens.agent.list.dialog.activateAgent.chooseOption]: 'Choose how you want to activate the agent',
  [tokens.agent.list.dialog.activateAgent.executeNow]: 'Execute Now',
  [tokens.agent.list.dialog.activateAgent.schedule]: 'Schedule',
  [tokens.agent.editor.availableNodes.searchPlaceholder.input]: 'Search input nodes...',
  [tokens.agent.editor.availableNodes.searchPlaceholder.processing]: 'Search processing nodes...',
  [tokens.agent.editor.availableNodes.searchPlaceholder.output]: 'Search output nodes...',
  [tokens.agent.editor.availableNodes.loading]: 'Loading...',
  [tokens.agent.editor.availableNodes.noResultsFound]: 'No results found',
  [tokens.agent.label.placeholderLabel]: 'Node name',
  [tokens.agent.label.selectFolder]: 'Select folder',
  [tokens.agent.editor.inputFolder.loadingFolders]: 'Loading folders...',
  [tokens.agent.editor.inputFolder.noFoldersFound]: 'No folders found',
  [tokens.agent.editor.inputFolder.selectFolderFirst]: 'Select a folder first',
  [tokens.agent.editor.inputFolder.selectFolderToPreview]: 'Select a folder to preview files',
  [tokens.agent.editor.inputFolder.loading]: 'Loading...',
  [tokens.agent.editor.inputFolder.noFilesFound]: 'No files found',
  [tokens.agent.editor.textInput.editContent]: 'Edit Content',
  [tokens.agent.editor.textInput.addContent]: 'Add Content',
  [tokens.agent.editor.textInput.preview]: 'Preview',
  [tokens.agent.editor.textInput.contentLabel]: 'Text Content',
  [tokens.agent.editor.textInput.contentPlaceholder]: 'Enter text here...',
  [tokens.agent.editor.consoleOutput.checkConsoleMessage]: 'Check the console to see the result',
  [tokens.agent.editor.llmGenerate.agentCharacteristics]: 'Agent Characteristics',
  [tokens.agent.editor.llmGenerate.personality.label]: 'Personality',
  [tokens.agent.editor.llmGenerate.personality.placeholder]: 'Ex: Helpful and knowledgeable assistant...',
  [tokens.agent.editor.llmGenerate.role.label]: 'Role',
  [tokens.agent.editor.llmGenerate.role.placeholder]: 'Ex: Writing assistant, Data analyst...',
  [tokens.agent.editor.llmGenerate.instructions.label]: 'Instructions',
  [tokens.agent.editor.llmGenerate.instructions.placeholder]: 'Add new instruction...',
  [tokens.agent.editor.llmGenerate.toneLabel]: 'Tone',
  [tokens.agent.editor.llmGenerate.tonePlaceholder]: 'Select communication tone',
  [tokens.agent.editor.llmGenerate.languageLabel]: 'Language',
  [tokens.agent.editor.llmGenerate.languagePlaceholder]: 'Select communication language',
  [tokens.agent.editor.llmGenerate.abilitiesLabel]: 'Abilities',
  [tokens.agent.editor.llmGenerate.tone.professional]: 'Professional',
  [tokens.agent.editor.llmGenerate.tone.casual]: 'Casual',
  [tokens.agent.editor.llmGenerate.tone.friendly]: 'Friendly',
  [tokens.agent.editor.llmGenerate.tone.formal]: 'Formal',
  [tokens.agent.editor.llmGenerate.language.auto]: 'Auto',
  [tokens.agent.editor.llmGenerate.language.english]: 'English',
  [tokens.agent.editor.llmGenerate.language.portuguese]: 'Portuguese',
  [tokens.agent.editor.llmGenerate.language.spanish]: 'Spanish',
  [tokens.agent.editor.llmGenerate.language.french]: 'French',
  [tokens.agent.editor.llmGenerate.language.italian]: 'Italian',
  [tokens.agent.editor.llmGenerate.abilities.fileSearch]: 'File Search',
  [tokens.agent.editor.llmGenerate.abilities.webSearch]: 'Web Search',
  [tokens.agent.editor.llmGenerate.abilities.planning]: 'Planning',
  [tokens.agent.editor.llmGenerate.abilities.imageAnalysis]: 'Image Analysis',
  [tokens.agent.editor.llmGenerate.instructions.title]: 'Instructions Editor',
  [tokens.agent.editor.textTranslator.requireReview.label]: 'Require Review',
  [tokens.agent.editor.textTranslator.requireReview.tooltip]: 'When enabled, translations will be sent for review before being finalized',
  [tokens.agent.editor.textTranslator.glossary.updateButton]: 'Update',
  [tokens.agent.editor.textTranslator.glossary.addButton]: 'Add',
  [tokens.agent.editor.textTranslator.glossary.cancelEditButton]: 'Cancel edit',
  [tokens.agent.editor.textTranslator.editInstructions]: 'Edit Instructions',
  [tokens.agent.editor.textTranslator.addInstructions]: 'Add Instructions',
  [tokens.agent.editor.llmGenerate.instructions.addButton]: 'Add Instruction',
  [tokens.agent.editor.textTranslator.sourceLanguageLabel]: 'Source Language',
  [tokens.agent.editor.textTranslator.sourceLanguagePlaceholder]: 'Select source language',
  [tokens.agent.editor.textTranslator.targetLanguageLabel]: 'Target Language',
  [tokens.agent.editor.textTranslator.targetLanguagePlaceholder]: 'Select target language',
  [tokens.agent.editor.textTranslator.instructionsLabel]: 'Translation Instructions',
  [tokens.agent.editor.textTranslator.instructionsPlaceholder]: 'Specific instructions for translation (tone, style, context, etc.)...',
  [tokens.agent.editor.textTranslator.language.english]: 'English',
  [tokens.agent.editor.textTranslator.language.portuguese]: 'Portuguese',
  [tokens.agent.editor.textTranslator.language.spanish]: 'Spanish',
  [tokens.agent.editor.textTranslator.language.french]: 'French',
  [tokens.agent.editor.textTranslator.language.italian]: 'Italian',
  [tokens.agent.editor.textTranslator.glossary.label]: 'Glossary',
  [tokens.agent.editor.textTranslator.glossary.termPlaceholder]: 'Term to be replaced',
  [tokens.agent.editor.textTranslator.glossary.translationPlaceholder]: 'Translation to be used',
  [tokens.agent.editor.textTranslator.glossary.tooltipTerm]: 'Term:',
  [tokens.agent.editor.textTranslator.glossary.tooltipTranslation]: 'Translation:',
  [tokens.agent.editor.textTranslator.glossary.searchPlaceholder]: 'Search term...',
  [tokens.agent.editor.textTranslator.glossary.noResultsFound]: 'No results found for {{searchTerm}}',
  [tokens.agent.editor.textTranslator.glossary.noResultsHint]: 'Try searching for other terms or translations',
  [tokens.agent.editor.textTranslator.glossary.emptyGlossary]: 'No terms in glossary',
  [tokens.agent.editor.textTranslator.glossary.emptyGlossaryHint]: 'Add terms using the fields above',
  [tokens.agent.editor.textTranslator.glossary.editingItem]: 'Editing item {{index}}',
  [tokens.agent.editor.formatTemplate.templateLabel]: 'Format Template',
  [tokens.agent.editor.formatTemplate.tagLabel]: 'Template Tag',
  [tokens.agent.editor.formatTemplate.tagPlaceholder]: 'Enter a tag to identify the template',
  [tokens.agent.editor.formatTemplate.tagTooltip]: 'The tag helps identify and organize the template',
  [tokens.agent.editor.formatTemplate.dragAndDropText]: 'Drag a file here or click to select',
  [tokens.agent.editor.formatTemplate.fileSize]: 'Size',
  [tokens.agent.editor.formatTemplate.uploading]: 'Uploading...',
  [tokens.agent.editor.formatTemplate.sendTemplate]: 'Send Template',
  [tokens.agent.editor.formatTemplate.cancel]: 'Cancel',
  [tokens.agent.editor.formatTemplate.replaceTemplate]: 'Replace Template',
  [tokens.agent.editor.formatTemplate.tooltip.supportedFormats]: 'Supported formats:',
  [tokens.agent.editor.formatTemplate.tooltip.formats]: 'DOCX DOC PDF',
  [tokens.agent.editor.formatTemplate.tooltip.maxSize]: 'Maximum size: 50MB',
  [tokens.agent.editor.formatTemplate.success.templateSent]: 'Template sent successfully',
  [tokens.agent.editor.formatTemplate.success.templateReplaced]: 'Template replaced successfully',
  [tokens.agent.editor.formatTemplate.errors.fileTooLarge.title]: 'File too large',
  [tokens.agent.editor.formatTemplate.errors.fileTooLarge.description]: 'The file {{fileName}} exceeds the {{maxSize}} MB limit and cannot be sent.',
  [tokens.agent.editor.formatTemplate.errors.unsupportedFormat.title]: 'Unsupported format',
  [tokens.agent.editor.formatTemplate.errors.unsupportedFormat.description]: 'The file format is not supported. Use only: {{formats}}',
  [tokens.agent.editor.formatTemplate.errors.uploadError.title]: 'Error sending template',
  [tokens.agent.editor.formatTemplate.errors.uploadError.description]: 'An error occurred while sending the template. Please try again.',
  [tokens.agent.editor.splitDocument.splitMode.label]: 'Split Mode',
  [tokens.agent.editor.splitDocument.splitMode.placeholder]: 'Select split mode',
  [tokens.agent.editor.splitDocument.splitMode.auto]: 'Automatic',
  [tokens.agent.editor.splitDocument.splitMode.ranges]: 'Page Ranges',
  [tokens.agent.editor.splitDocument.splitMode.rangesDescription]: 'Split the document into specific intervals or pages',
  [tokens.agent.editor.splitDocument.pages.label]: 'Pages',
  [tokens.agent.editor.splitDocument.pages.tooltip]: 'Split from page {{start}} to {{end}}',
  [tokens.agent.editor.splitDocument.auto.title]: 'Smart Split',
  [tokens.agent.editor.splitDocument.auto.description]: 'Identifies the best cutting points automatically.',
  [tokens.agent.editor.extractContent.textExtraction]: 'Text Extraction',
  [tokens.agent.editor.extractContent.extractText]: 'Extract text from documents',
  [tokens.agent.editor.extractContent.imageExtraction]: 'Image Extraction',
  [tokens.agent.editor.extractContent.extractImages]: 'Extract images from documents',
  [tokens.agent.editor.recordAudio.title]: 'Audio Recording',
  [tokens.agent.editor.recordAudio.tooltip]: 'Record audio from microphone and selected screen',
  [tokens.agent.editor.recordAudio.fileInfo.size]: 'Size',
  [tokens.agent.editor.recordAudio.fileInfo.duration]: 'Duration',
  [tokens.agent.editor.recordAudio.browserSupport.apisNotSupported]: 'Browser not compatible',
  [tokens.agent.editor.recordAudio.browserSupport.mediaDevicesNotSupported]: 'Your browser does not support access to media devices.',
  [tokens.agent.editor.recordAudio.browserSupport.featuresNotSupported]: 'Features not supported',
  [tokens.agent.editor.recordAudio.browserSupport.microphoneNotSupported]: 'Your browser does not support microphone access.',
  [tokens.agent.editor.recordAudio.browserSupport.screenShareNotSupported]: 'Your browser does not support screen sharing.',
  [tokens.agent.editor.recordAudio.browserSupport.mediaRecorderNotSupported]: 'Your browser does not support media recording.',
  [tokens.agent.editor.recordAudio.permissions.permissionRequired]: 'Permission required',
  [tokens.agent.editor.recordAudio.permissions.allowMicrophoneAccess]: 'Allow microphone access to continue...',
  [tokens.agent.editor.recordAudio.permissions.selectArea]: 'Select the area',
  [tokens.agent.editor.recordAudio.permissions.selectScreenForAudio]: 'Now select the screen/window to record audio...',
  [tokens.agent.editor.recordAudio.screenAudio.screenAudioNotAvailable]: 'Screen audio not available',
  [tokens.agent.editor.recordAudio.screenAudio.shareAudioCheckbox]: 'Make sure to check \'Share audio\' in the selection window.',
  [tokens.agent.editor.recordAudio.upload.uploadError]: 'Upload error',
  [tokens.agent.editor.recordAudio.upload.failedToSendAudio]: 'Failed to send audio file.',
  [tokens.agent.editor.recordAudio.upload.recordingSent]: 'Recording sent',
  [tokens.agent.editor.recordAudio.upload.audioFileSentSuccessfully]: 'The audio file was sent successfully.',
  [tokens.agent.editor.recordAudio.recording.recordingError]: 'Recording error',
  [tokens.agent.editor.recordAudio.recording.noAudioDataCaptured]: 'No audio data was captured.',
  [tokens.agent.editor.recordAudio.recording.recordingStarted]: 'Recording started',
  [tokens.agent.editor.recordAudio.recording.recordingMicrophoneAndScreen]: 'Recording audio from microphone and selected screen.',
  [tokens.agent.editor.recordAudio.errors.permissionDenied]: 'Permission denied',
  [tokens.agent.editor.recordAudio.errors.allowMicrophoneAndScreenAccess]: 'Allow microphone access and screen sharing to continue.',
  [tokens.agent.editor.recordAudio.errors.deviceNotFound]: 'Device not found',
  [tokens.agent.editor.recordAudio.errors.microphoneOrScreenNotFound]: 'Microphone or screen not found.',
  [tokens.agent.editor.recordAudio.errors.recordingCancelled]: 'Recording cancelled',
  [tokens.agent.editor.recordAudio.errors.selectionCancelledByUser]: 'The selection was cancelled by the user.',
  [tokens.agent.editor.recordAudio.errors.unknownErrorStartingRecording]: 'Unknown error starting recording, check if the browser supports audio and screen recording.',
  [tokens.agent.editor.recordAudio.actions.startRecording]: 'Start Recording',
  [tokens.agent.editor.recordAudio.actions.stopRecording]: 'Stop Recording',
  [tokens.agent.editor.recordAudio.confirmDialog.newRecording]: 'New Recording',
  [tokens.agent.editor.recordAudio.confirmDialog.previousRecordingWillBeLost]: 'When starting a new recording, the previous recording will be permanently lost. Do you want to start a new recording?',
  [tokens.agent.editor.recordAudio.confirmDialog.yes]: 'Yes',
  [tokens.agent.editor.recordAudio.browserNotSupported]: 'Your browser does not support the audio element.',
  [tokens.agent.nodes.audioTranscription.name]: 'Audio Transcription',
  [tokens.agent.nodes.audioTranscription.description]: 'Transcribes audio files to text',
  [tokens.agent.editor.audioTranscription.audioLanguage.label]: 'Audio Language',
  [tokens.agent.editor.audioTranscription.audioLanguage.placeholder]: 'Select language',
  [tokens.agent.editor.audioTranscription.audioLanguage.description]: 'Language of the audio file that will be transcribed. Specifying the correct language significantly improves the accuracy and quality of the transcription, reducing interpretation errors.',
  [tokens.agent.editor.audioTranscription.language.portuguese]: 'Portuguese',
  [tokens.agent.editor.audioTranscription.language.english]: 'English',
  [tokens.agent.editor.audioTranscription.language.spanish]: 'Spanish',
  [tokens.agent.editor.audioTranscription.language.french]: 'French',
  [tokens.agent.editor.audioTranscription.language.italian]: 'Italian',
  [tokens.agent.validation.messages.audioTranscriptionNodeNeedsLanguage]: 'The {nodeName} node needs to have an audio language configured',
  [tokens.agent.nodes.generateReport.name]: 'Generate Report',
  [tokens.agent.nodes.generateReport.description]: 'Generates structured reports based on input data',
  [tokens.agent.editor.generateReport.instructions.label]: 'Report Instructions',
  [tokens.agent.editor.generateReport.instructions.placeholder]: 'Enter specific instructions for report generation...',
  [tokens.agent.editor.generateReport.instructions.description]: 'Specific instructions that will guide report generation, such as format, style, or special requirements',
  [tokens.agent.editor.generateReport.reportOptions.label]: 'Report Options',
  [tokens.agent.editor.generateReport.reportOptions.summary]: 'Include Summary',
  [tokens.agent.editor.generateReport.reportOptions.importantDates]: 'Include Important Dates',
  [tokens.agent.editor.generateReport.reportOptions.tasks]: 'Include Tasks',
  [tokens.agent.editor.generateReport.reportOptions.conclusion]: 'Include Conclusion',
  [tokens.agent.editor.generateReport.reportOptions.chartGeneration]: 'Enable Chart Generation',
  [tokens.agent.nodes.recordAudio.name]: 'Audio Recording',
  [tokens.agent.nodes.recordAudio.description]: 'Allows recording audio directly in the browser',
  [tokens.agent.nodes.formatTemplate.name]: 'Format Template',
  [tokens.agent.nodes.formatTemplate.description]: 'Formats content using templates',
  [tokens.agent.nodes.extractContent.name]: 'Content Extraction',
  [tokens.agent.nodes.extractContent.description]: 'Extracts content from documents based on provided rules',
  [tokens.agent.console.title]: 'Results Console',
  [tokens.agent.console.status.label]: 'Status',
  [tokens.agent.console.status.error]: 'Error',
  [tokens.agent.console.status.completed]: 'Completed',
  [tokens.agent.console.status.processing]: 'Processing',
  [tokens.agent.console.status.connected]: 'Connected',
  [tokens.agent.console.status.quotaExceeded]: 'Quota Exceeded',
  [tokens.agent.console.waitingForProcessing]: 'Waiting for processing...',
  [tokens.agent.console.totalMessages]: 'Total messages',
  [tokens.agent.console.stopButton]: 'Stop',
  [tokens.agent.controls.unsavedChanges]: 'Unsaved changes',
  [tokens.agent.controls.saveTooltip]: 'Save to server',
  [tokens.agent.controls.saving]: 'Saving...',
  [tokens.agent.controls.saved]: 'Saved!',
  [tokens.agent.controls.saveError]: 'Save error',
  [tokens.agent.controls.save]: 'Save',
  [tokens.agent.controls.stopExecution]: 'Stop execution',
  [tokens.agent.controls.startExecution]: 'Start execution',
  [tokens.agent.nodes.defaultInputNode]: 'Input Node',
  [tokens.agent.nodes.selectInputNode]: 'Select an input node',
  [tokens.agent.nodes.defaultProcessingNode]: 'Processing Node',
  [tokens.agent.nodes.selectProcessingNode]: 'Select a processing node',
  [tokens.agent.nodes.defaultOutputNode]: 'Output Node',
  [tokens.agent.nodes.selectOutputNode]: 'Select an output node',
  [tokens.agent.nodes.defaultNode]: 'Node',
  [tokens.agent.nodes.label.resultType]: 'Result Type',
  [tokens.agent.nodes.label.attachment]: 'Attachment',
  [tokens.agent.nodes.label.body]: 'Body',
  [tokens.agent.dragDrop.errorAddingNode]: 'Error adding node',
  [tokens.agent.websocket.startingConnection]: 'Starting connection...',
  [tokens.agent.websocket.errorAgentIdNotSpecified]: 'Error: Agent ID not specified',
  [tokens.agent.websocket.errorProcessingMessage]: 'Error processing message',
  [tokens.agent.websocket.errorConnectingToServer]: 'Error when connecting to the server',
  [tokens.agent.websocket.connectionClosed]: 'Connection closed',
  [tokens.agent.websocket.connectionInterrupted]: 'Connection interrupted',
  [tokens.agent.websocket.executionCompletedSuccess]: 'Execution completed successfully',
  [tokens.agent.websocket.executionCompletedError]: 'Execution completed with error',
  [tokens.agent.websocket.quotaInsufficient]: 'Insufficient quota',
  [tokens.agent.flow.errorReloadingData]: 'Error reloading data',
  [tokens.agent.flow.couldNotUpdateDataAfterStop]: 'Could not update data after stopping execution',
  [tokens.agent.flow.errorOnSave]: 'Error on save',
  [tokens.agent.flow.couldNotStartExecution]: 'Could not start execution',
  [tokens.agent.flow.agentNamePlaceholder]: 'Agent name',
  [tokens.agent.workflow.errorLoadingAgent]: 'Error loading agent',
  [tokens.agent.workflow.pleaseTryAgain]: 'Please try again',
  [tokens.agent.loading.loadingFlowFromServer]: 'Loading flow from server...',
  [tokens.agent.nodes.inputFolder.name]: 'Folder Input',
  [tokens.agent.nodes.inputFolder.description]: 'Node to process folder inputs and retrieve files',
  [tokens.agent.nodes.textInput.name]: 'Simple Text Input',
  [tokens.agent.nodes.textInput.description]: 'A simple input node that receives a text',
  [tokens.agent.nodes.documentComparison.name]: 'Compare Documents',
  [tokens.agent.nodes.documentComparison.description]: 'A node that compares documents based on provided rules and generates an HTML comparison report',
  [tokens.agent.nodes.textTranslator.name]: 'Translate Text',
  [tokens.agent.nodes.textTranslator.description]: 'A node that translates text between different languages using AI',
  [tokens.agent.nodes.llmGenerate.name]: 'Generate Text',
  [tokens.agent.nodes.llmGenerate.description]: 'A customizable node for LLM text generation with agent characteristics and configurable capabilities',
  [tokens.agent.nodes.outputFolder.name]: 'Save Results to Folder',
  [tokens.agent.nodes.outputFolder.description]: 'Output node to save files to folders',
  [tokens.agent.nodes.consoleOutput.name]: 'Console Log',
  [tokens.agent.nodes.consoleOutput.description]: 'A simple output node that logs the result to the console',
  [tokens.agent.nodes.splitDocument.name]: 'Split document',
  [tokens.agent.nodes.splitDocument.description]: 'Node to split documents into smaller parts',
  [tokens.agent.validation.hasValidationWarnings]: 'There are validation warnings',
  [tokens.agent.validation.workflowValid]: 'Valid workflow',
  [tokens.agent.validation.warningsClickToSeeDetails]: 'See details',
  [tokens.agent.validation.warnings]: 'Warnings',
  [tokens.agent.validation.nodeTypes.textInput]: 'Text input node',
  [tokens.agent.validation.nodeTypes.inputFolder]: 'Input folder node',
  [tokens.agent.validation.nodeTypes.outputFolder]: 'Output folder node',
  [tokens.agent.validation.nodeTypes.consoleOutput]: 'Console output node',
  [tokens.agent.validation.nodeTypes.textTranslator]: 'Text translator node',
  [tokens.agent.validation.nodeTypes.llmGenerate]: 'LLM generation node',
  [tokens.agent.validation.nodeTypes.documentComparison]: 'Document comparison node',
  [tokens.agent.validation.nodeTypes.formatTemplate]: 'Template formatting node',
  [tokens.agent.validation.nodeTypes.extractContent]: 'Content extraction node',
  [tokens.agent.validation.nodeTypes.input]: 'Input node',
  [tokens.agent.validation.nodeTypes.processing]: 'Processing node',
  [tokens.agent.validation.nodeTypes.output]: 'Output node',
  [tokens.agent.validation.nodeTypes.inputFile]: 'File input node',
  [tokens.agent.validation.nodeTypes.node]: 'Node',
  [tokens.agent.validation.messages.agentNameRequired]: 'Agent name must be defined',
  [tokens.agent.validation.messages.workflowNeedsNodes]: 'The workflow needs at least one node',
  [tokens.agent.validation.messages.workflowNeedsInputNodes]: 'The workflow needs at least one input node',
  [tokens.agent.validation.messages.workflowNeedsOutputNodes]: 'The workflow needs at least one output node',
  [tokens.agent.validation.messages.nodeLabelRequired]: '{{nodeName}} needs to have a label defined',
  [tokens.agent.validation.messages.nodeNotConnected]: '{{nodeName}} is not connected to the workflow',
  [tokens.agent.validation.messages.nodeNeedsInput]: '{{nodeName}} needs at least one input',
  [tokens.agent.validation.messages.nodeNeedsOutput]: '{{nodeName}} needs at least one output',
  [tokens.agent.validation.messages.workflowCannotHaveCycles]: 'The workflow cannot have cycles (circular references)',
  [tokens.agent.validation.messages.nodeNotConfigured]: '{{nodeName}} is not configured. Choose a type to configure.',
  [tokens.agent.validation.messages.textInputCannotBeEmpty]: '{{nodeName}} cannot be empty',
  [tokens.agent.validation.messages.folderNodeNeedsFolder]: '{{nodeName}} needs to have a folder selected',
  [tokens.agent.validation.messages.translatorNodeNeedsConfig]: '{{nodeName}} needs to be configured',
  [tokens.agent.validation.messages.translatorNodeNeedsSourceLanguage]: '{{nodeName}} needs to have the source language defined',
  [tokens.agent.validation.messages.translatorNodeNeedsTargetLanguage]: '{{nodeName}} needs to have the target language defined',
  [tokens.agent.validation.messages.translatorNodeNeedsDifferentLanguages]: '{{nodeName}} needs to have different source and target languages',
  [tokens.agent.validation.messages.llmNodeNeedsConfig]: '{{nodeName}} needs to be configured',
  [tokens.agent.validation.messages.llmNodeNeedsInstructions]: '{{nodeName}} needs to have at least one instruction defined',
  [tokens.agent.validation.messages.formatTemplateNeedsTag]: '{{nodeName}} needs to have a tag defined',
  [tokens.agent.validation.messages.formatTemplateNeedsFile]: '{{nodeName}} needs to have a template uploaded',
  [tokens.agent.validation.messages.splitDocumentNeedsRanges]: '{{nodeName}} needs to have at least one range defined when "Page Ranges" mode is selected',
  [tokens.agent.validation.messages.extractContentNeedsSelection]: '{{nodeName}} needs to have at least one extraction option selected',
  [tokens.agent.validation.nodeTypes.restApiOutput]: 'REST API Output Node',
  [tokens.agent.validation.messages.restApiNodeNeedsUrl]: '{{nodeName}} node needs a valid URL',
  [tokens.agent.validation.messages.restApiNodeNeedsMethod]: '{{nodeName}} node needs an HTTP method',
  [tokens.agent.validation.messages.restApiNodeNeedsValidTimeout]: 'The timeout for {{nodeName}} node must be between 1000 and 30000 ms',
  [tokens.agent.validation.messages.recordAudioNeedsFile]: '{{nodeName}} needs an audio recording',
  [tokens.executionNodeData.noDataAvailable]: 'No data available',
  [tokens.executionNodeData.input]: 'Input',
  [tokens.executionNodeData.output]: 'Output',
  [tokens.executionNodeData.noInputOutputData]: 'No input or output data available for this node.',
  [tokens.agent.executions.status.skipped]: 'Skipped',
  [tokens.agent.editor.fileInput.fileLabel]: 'File',
  [tokens.agent.editor.fileInput.tooltip.supportedFormats]: 'Supported formats:',
  [tokens.agent.editor.fileInput.tooltip.maxSize]: 'Maximum size: 50MB',
  [tokens.agent.editor.fileInput.fileSize]: 'Size',
  [tokens.agent.editor.fileInput.sendFile]: 'Send file',
  [tokens.agent.editor.fileInput.uploading]: 'Uploading...',
  [tokens.agent.editor.fileInput.cancel]: 'Cancel',
  [tokens.agent.editor.fileInput.replaceFile]: 'Replace file',
  [tokens.agent.editor.fileInput.success.fileSent]: 'File sent successfully',
  [tokens.agent.editor.fileInput.errors.unsupportedFormat.title]: 'Unsupported format',
  [tokens.agent.editor.fileInput.errors.fileTooLarge.title]: 'File too large',
  [tokens.agent.editor.fileInput.errors.fileTooLarge.description]: 'The file exceeds the maximum size of 50MB.',
  [tokens.agent.editor.fileInput.errors.uploadError.title]: 'Upload error',
  [tokens.agent.editor.fileInput.errors.uploadError.description]: 'An error occurred while sending the file. Please try again.',
  [tokens.agent.editor.changeNodeType]: 'Change node type',
  [tokens.agent.nodes.fileInput.name]: 'File Input',
  [tokens.agent.nodes.fileInput.description]: 'Receives a file as input for the workflow',
  [tokens.agent.validation.messages.fileInputNeedsFile]: '{{nodeName}} needs a selected file',
  [tokens.agent.editor.fileInput.errors.unsupportedFormat.description]: 'The file format is not supported. Use only: {{formats}}',
  [tokens.agent.nodes.restApiOutput.name]: 'REST API Output',
  [tokens.agent.nodes.restApiOutput.description]: 'Sends data to an external REST API',
  [tokens.agent.label.restApiConfiguration]: 'REST API Configuration',
  [tokens.agent.label.url]: 'URL',
  [tokens.agent.label.method]: 'Method',
  [tokens.agent.label.timeout]: 'Timeout (ms)',
  [tokens.agent.label.headers]: 'Headers',
  [tokens.agent.label.headerKey]: 'Key',
  [tokens.agent.label.headerValue]: 'Value',
  [tokens.agent.nodes.emailOutput.name]: 'Email Output',
  [tokens.agent.nodes.emailOutput.description]: 'Sends results via email to specified recipients',
  [tokens.agent.label.emailConfiguration]: 'Email Configuration',
  [tokens.agent.label.recipients]: 'Recipients',
  [tokens.agent.label.subject]: 'Subject',
  [tokens.agent.label.addRecipient]: 'Add Recipient',
  [tokens.agent.label.removeRecipient]: 'Remove Recipient',
  [tokens.agent.validation.messages.emailNodeNeedsRecipients]: '{{nodeName}} needs at least one recipient',
  [tokens.agent.validation.messages.emailNodeNeedsValidEmails]: '{{nodeName}} needs valid email addresses',
  [tokens.agent.validation.nodeTypes.emailOutput]: 'Email Output Node',
  [tokens.agent.editor.textTranslator.review.title]: 'Text Translator Review',
  [tokens.agent.editor.textTranslator.review.success.title]: 'Success',
  [tokens.agent.editor.textTranslator.review.success.description]: 'Review submitted successfully',
  [tokens.agent.editor.textTranslator.review.error.title]: 'Error',
  [tokens.agent.editor.textTranslator.review.error.description]: 'Failed to submit review. Please try again.',
  [tokens.agent.editor.textTranslator.review.reprocessTooltip]: 'Reprocess translation',
  [tokens.agent.editor.textTranslator.review.rejectButton]: 'Reject',
  [tokens.agent.editor.textTranslator.review.approveButton]: 'Approve',
  [tokens.agent.editor.textTranslator.reprocess.title]: 'Reprocess',
  [tokens.agent.editor.textTranslator.reprocess.placeholder]: 'Describe what needs to be corrected in the translation...',
  [tokens.agent.editor.textTranslator.reprocess.cancel]: 'Cancel',
  [tokens.agent.editor.textTranslator.reprocess.button]: 'Reprocess',
  [tokens.agent.editor.recordAudio.sendToWorkstationTooltip]: 'Save the recorded audio to the workstation\nto use in future conversations with Alan',
  [tokens.agent.editor.recordAudio.sendToWorkstation]: 'Send to Workstation',
  [tokens.agent.executions.continueStarted.title]: 'Execution continued',
  [tokens.agent.executions.continueStarted.description]: 'The execution has been continued successfully.',
  [tokens.agent.executions.errors.continueError]: 'Error continuing execution',
  [tokens.agent.executions.errors.unknownError]: 'Unknown error',
  [tokens.agent.executions.status.notExecuted]: 'Not executed',
  [tokens.agent.executions.review.pending]: 'Pending review',
  [tokens.agent.websocket.reviewRequired]: 'Review required',
  [tokens.agent.executions.errorFetchingPendingReviews]: 'Failed to fetch pending reviews',
  [tokens.agent.executions.tryAgainLater]: 'Please try again later',
  [tokens.agent.executions.status.review]: 'Review',
  [tokens.agent.executions.status.canceled]: 'Canceled',
  [tokens.agent.editor.textTranslator.documentViewer.notSupported]: 'Viewing not supported at the moment',
  [tokens.agent.editor.textTranslator.documentViewer.format]: 'Format',
  [tokens.agent.editor.textTranslator.documentViewer.title]: 'Document Viewer',
  [tokens.agent.editor.textTranslator.glossary.editTitle]: 'Edit Glossary',
  [tokens.agent.editor.textTranslator.glossary.addTitle]: 'Add Glossary',
  [tokens.agent.editor.textTranslator.glossary.termsLabel]: 'Terms',
  [tokens.agent.editor.textTranslator.glossary.removeTerm]: 'Remove term',
  [tokens.agent.editor.textTranslator.glossary.closeButton]: 'Close',
  [tokens.agent.editor.textTranslator.glossary.saveButton]: 'Save',
  [tokens.agent.editor.textTranslator.glossary.searchPlaceholder]: 'Search term...',
  [tokens.agent.editor.textTranslator.glossary.loadingGlossaries]: 'Loading glossaries...',
  [tokens.agent.editor.textTranslator.glossary.editAction]: 'Edit',
  [tokens.agent.editor.textTranslator.glossary.duplicateAction]: 'Duplicate',
  [tokens.agent.editor.textTranslator.glossary.deleteAction]: 'Delete',
  [tokens.agent.editor.textTranslator.glossary.deleteConfirmTitle]: 'Delete glossary?',
  [tokens.agent.editor.textTranslator.glossary.deleteConfirmDescription]: 'This action will delete the selected glossary. It cannot be undone.',
  [tokens.agent.editor.textTranslator.glossary.cancelButton]: 'Cancel',
  [tokens.agent.editor.textTranslator.glossary.confirmDeleteButton]: 'Delete',
  [tokens.agent.editor.textTranslator.glossary.viewTitle]: 'View glossary',
  [tokens.agent.editor.textTranslator.glossary.loadingGlossary]: 'Loading...',
  [tokens.files.title]: 'File Manager',
  [tokens.files.subtitle]: 'Manage your folders and files here.',
  [tokens.files.storage.title]: 'Workstation Storage',
  [tokens.files.storage.used]: '0.00 MB of 500 MB',
  [tokens.files.storage.locked]: '0%',
  [tokens.files.integration.title.googledrive]: 'Google Drive',
  [tokens.files.integration.title.onedrive]: 'OneDrive',
  [tokens.files.integration.title.sharepoint]: 'SharePoint',
  [tokens.files.myFolders]: 'My folders',
  [tokens.files.search.placeholder]: 'Search folders…',
  [tokens.files.folderTable.name]: 'Name',
  [tokens.files.folderTable.items]: 'Items',
  [tokens.files.folderTable.size]: 'Size',
  [tokens.files.folderTable.createdAt]: 'Created at',
  [tokens.files.folderTable.type]: 'Type',
  [tokens.files.folderTable.private]: 'Private',
  [tokens.files.folderTable.new]: 'New Folder',
  [tokens.files.folderTable.editFolder]: 'Edit folder',
  [tokens.files.folderTable.deleteFolder]: 'Delete folder',
  [tokens.files.folderTable.access.allowedGroups]: 'Allowed groups',
  [tokens.files.folderTable.access.allowedUsers]: 'Allowed users',
  [tokens.files.folderTable.access.selectMembers]: 'Select members',
  [tokens.files.folderTable.access.selectGroups]: 'Select groups',
  [tokens.files.folderTable.access.selectAllGroups]: 'Select all',
  [tokens.files.folderTable.access.selectAllMembers]: 'Select all',
  [tokens.files.folderTable.createFolder.folderName]: 'Folder Name',
  [tokens.files.folderTable.createFolder.title]: 'Create Folder',
  [tokens.files.folderTable.noResults]: 'No folders found.',
  [tokens.files.folderTable.searching]: 'Searching folders...',
  [tokens.files.fileTable.filter]: 'Filter files...',
  [tokens.files.fileTable.name]: 'File Name',
  [tokens.files.fileTable.size]: 'Size (Mb)',
  [tokens.files.fileTable.status]: 'Status',
  [tokens.files.fileTable.uploadedAt]: 'Upload at',
  [tokens.files.fileTable.uploadCompleted]: 'Completed',
  [tokens.files.fileTable.uploadFile]: 'Upload file',
  [tokens.files.fileTable.noResults]: 'No results, start uploading files to the selected folder',
  [tokens.integrations.title]: 'App Integrations',
  [tokens.integrations.description]: 'Here\'s a list of your apps for the integration!',
  [tokens.integrations.filter.placeholder]: 'Filter apps...',
  [tokens.integrations.filter.all]: 'All Apps',
  [tokens.integrations.filter.connected]: 'Connected',
  [tokens.integrations.filter.notConnected]: 'Not Connected',
  [tokens.integrations.card.comingSoon]: 'Coming soon',
  [tokens.integrations.card.googleDrive.title]: 'Google Drive',
  [tokens.integrations.card.googleDrive.description]: 'Connect with Google Drive to manage your files.',
  [tokens.integrations.card.microsoft.title]: 'Microsoft',
  [tokens.integrations.card.microsoft.description]: 'Connect with OneDrive and SharePoint to manage your files.',
  [tokens.integrations.card.whatsapp.title]: 'WhatsApp',
  [tokens.integrations.card.whatsapp.description]: 'Easily integrate WhatsApp for direct messaging.',
  [tokens.settings.title]: 'Settings',
  [tokens.settings.subtitle]: 'Manage your account settings and preferences.',
  [tokens.settings.usage.title]: 'Usage',
  [tokens.settings.usage.subtitle]: 'View your usage statistics.',
  [tokens.settings.usage.subtitleHistory]: 'Track your resource consumption over time.',
  [tokens.settings.usage.questionsAsked]: 'Questions asked',
  [tokens.settings.usage.processedPages]: 'Processed pages',
  [tokens.settings.usage.minutesUsed]: 'Minutes used',
  [tokens.settings.usage.organizationMembers]: 'Organization members',
  [tokens.settings.usage.upgradePlan]: 'Upgrade Plan',
  [tokens.settings.usage.usageLimitCredits]: 'After reaching the usage limit, credits will be used.',
  [tokens.settings.usage.viewCredits]: 'View credits',
  [tokens.settings.usage.maxMbUpload]: 'Upload Limit (MB)',
  [tokens.settings.usage.filters.questions]: 'Questions',
  [tokens.settings.usage.filters.pages]: 'Processed pages',
  [tokens.settings.usage.filters.minutes]: 'Minutes used',
  [tokens.settings.usage.filters.charges]: 'Recharges',
  [tokens.settings.usage.filters.agentExecutedNodes]: 'Agent executed nodes',
  [tokens.settings.usage.filters.assistants]: 'Assistants',
  [tokens.settings.usage.filters.mbDocs]: 'MB Documents',
  [tokens.settings.usage.filters.mbSpreadsheets]: 'MB Spreadsheets',
  [tokens.settings.usage.filters.mbTranslator]: 'MB Translator (month)',
  [tokens.settings.members.title]: 'Members',
  [tokens.settings.members.subtitle]: 'Manage members of your organization.',
  [tokens.settings.members.invite]: 'Invite members',
  [tokens.settings.members.noMembersFound]: 'No members found',
  [tokens.settings.members.noMembersSearchMatch]: 'No members match your search criteria. Try a different search term or add a new member.',
  [tokens.settings.members.noMembersAddedMessage]: 'You haven\'t added any members yet.',
  [tokens.settings.members.inviteDescription]: 'Invite new members to your organization here. Click save when finished.',
  [tokens.settings.members.filter]: 'Filter members',
  [tokens.settings.members.fields.name]: 'Name',
  [tokens.settings.members.validation.emailRequired]: 'Email is required',
  [tokens.settings.members.validation.nameRequired]: 'Name is required',
  [tokens.settings.members.you]: 'You',
  [tokens.settings.groups.title]: 'Groups',
  [tokens.settings.groups.subtitle]: 'Manage user groups and their permissions.',
  [tokens.settings.groups.createGroup]: 'Create group',
  [tokens.settings.groups.filterGroup]: 'Filter groups...',
  [tokens.settings.groups.name]: 'Group name',
  [tokens.settings.groups.membersLabel]: 'Member',
  [tokens.settings.groups.membersLabel_other]: 'Members',
  [tokens.settings.groups.permissionsLabel]: 'Permission',
  [tokens.settings.groups.permissionsLabel_other]: 'Permissions',
  [tokens.settings.groups.selectPermissions]: 'Select permissions',
  [tokens.settings.groups.delete.confirmation]: 'Are you sure you want to delete this group? This action cannot be undone.',
  [tokens.settings.groups.delete.warning]: 'Deleting this group will remove all permissions associated with users in this group.',
  [tokens.settings.groups.delete.title]: 'Delete Group "{{currentGroup}}"',
  [tokens.settings.groups.add.title]: 'Add New Group',
  [tokens.settings.groups.add.description]: 'Create a new group here. Click save when you\'re done.',
  [tokens.settings.groups.noGroupsFound]: 'No groups found',
  [tokens.settings.groups.noGroupsSearchMatch]: 'No groups match your search criteria. Try a different search term or create a new group.',
  [tokens.settings.groups.noGroupsAddedMessage]: 'You haven\'t created any groups yet. Groups help you organize users and manage permissions.',
  [tokens.settings.appearance.preferences.title]: 'Preferences',
  [tokens.settings.appearance.preferences.subtitle]: 'Customize your platform preferences',
  [tokens.settings.appearance.logo.title]: 'Organization Logo',
  [tokens.settings.appearance.logo.subtitle]: 'Personalize your organization by changing the logo.',
  [tokens.settings.appearance.logo.maxSize]: 'Recommend size',
  [tokens.settings.appearance.organization.name.title]: 'Organization Name',
  [tokens.settings.appearance.organization.name.subtitle]: 'Change the name of your organization.',
  [tokens.settings.appearance.font]: 'Font',
  [tokens.settings.appearance.fontDescription]: 'Set the font you want to use in the dashboard.',
  [tokens.settings.appearance.theme.title]: 'Theme',
  [tokens.settings.appearance.themeDescription]: 'Select the theme for the dashboard.',
  [tokens.settings.appearance.theme.light]: 'Light',
  [tokens.settings.appearance.theme.dark]: 'Dark',
  [tokens.settings.appearance.save]: 'Save preferences',
  [tokens.settings.billing.title]: 'Billing',
  [tokens.settings.billing.subtitle]: 'Manage your billing information.',
  [tokens.settings.billing.subtitleHistory]: 'Track your billing history over time.',
  [tokens.settings.billing.creditBalance]: 'Credit balance',
  [tokens.settings.billing.addCredit]: 'Add to credit balance',
  [tokens.settings.billing.managePlan]: 'Manage plan',
  [tokens.settings.billing.plan_attention.title]: 'Plan Requires Attention',
  [tokens.settings.billing.plan_attention.description]: 'Your plan needs to be renewed or additional credits added to continue using this feature.',
  [tokens.settings.billing.plan_attention.cta]: 'View my plan',
  [tokens.settings.billing.autoRecharge]: 'Auto recharge',
  [tokens.settings.billing.autoRechargeDescription]: 'When your credit balance reaches {{triggerAmount}}, your payment method will be recharged to bring the balance up to {{rechargeAmount}}. Up to a maximum value of {{monthlyLimit}}.',
  [tokens.settings.billing.modify]: 'Modify',
  [tokens.settings.billing.ensureDefaultPaymentMethod]: 'Ensure that a default payment method is set.',
  [tokens.settings.billing.availableCreditsTooltip]: 'This is the amount of credits you have available. Credits will only be consumed when an item in your quota reaches its maximum limit.',
  [tokens.settings.billing.credits.add]: 'Add Credits',
  [tokens.settings.billing.credits.total_amount]: 'Total Amount',
  [tokens.settings.billing.credits.common_options]: 'Common options',
  [tokens.settings.billing.credits.add_specific]: 'Add ${{creditAmount}} Credits',
  [tokens.settings.billing.credits.monthly_limit]: 'Monthly Limit',
  [tokens.settings.billing.credits.monthly_limit_tooltip]: 'The maximum amount of automatic recharges allowed per month. This safeguard ensures your account cannot exceed a predetermined budget, providing financial control and predictability.',
  [tokens.settings.billing.credits.auto_recharge_settings]: 'Auto Recharge Settings',
  [tokens.settings.billing.credits.trigger_amount]: 'Trigger Amount',
  [tokens.settings.billing.credits.trigger_amount_tooltip]: 'The threshold at which an automatic recharge is initiated. When your credit balance falls below this amount, the system will automatically replenish your account.',
  [tokens.settings.billing.credits.target_amount]: 'Target Amount',
  [tokens.settings.billing.credits.target_amount_tooltip]: 'The credit balance to be achieved after an automatic recharge. The system will add sufficient funds to reach this amount when a recharge is triggered.',
  [tokens.settings.billing.credits.save_changes]: 'Save changes',
  [tokens.settings.billing.history.paid]: 'Paid',
  [tokens.settings.billing.history.pending]: 'Pending',
  [tokens.settings.billing.view.receipt]: 'View receipt',
  [tokens.settings.apiKey.title]: 'API Keys',
  [tokens.settings.apiKey.subtitle]: 'Generate and manage your keys here.',
  [tokens.settings.apiKey.createButton]: 'Create API Key',
  [tokens.settings.apiKey.searchMessage]: 'Searching...',
  [tokens.settings.apiKey.noTokensFoundMessage]: 'No tokens found.',
  [tokens.settings.apiKey.createToastSuccess]: 'Token created successfully.',
  [tokens.settings.apiKey.createDialogSubtitle]: 'Create a new API key here. Click save when you\'re done.',
  [tokens.settings.apiKey.baseDialog.expiresAt]: 'Expiration date',
  [tokens.settings.apiKey.baseDialog.expiresAtOptions.fifteenDays]: '15 days',
  [tokens.settings.apiKey.baseDialog.expiresAtOptions.thirtyDays]: '30 days',
  [tokens.settings.apiKey.baseDialog.expiresAtOptions.never]: 'Never',
  [tokens.settings.apiKey.baseDialog.system]: 'System',
  [tokens.settings.apiKey.baseDialog.systemTokenTooltip]: 'System tokens are used to authenticate requests to the API. They are not linked to a specific user, so you must manually assign the necessary permissions. When the "system" option is disabled, the token is tied to a user and follows that user\'s assigned permissions.',
  [tokens.settings.apiKey.copyNewTokenDialog.title]: 'Copy your token',
  [tokens.settings.apiKey.copyNewTokenDialog.description]: 'Copy your token now. It won\'t be shown again. Store it in a safe place.',
  [tokens.settings.apiKey.tableColumns.name]: 'Name',
  [tokens.settings.apiKey.tableColumns.apiKey]: 'API Key',
  [tokens.settings.apiKey.tableColumns.createdAt]: 'Created at',
  [tokens.settings.apiKey.tableColumns.permissions]: 'Permissions',
  [tokens.settings.apiKey.tableColumns.noPermissionsTooltip]: 'No permissions',
  [tokens.settings.apiKey.tableColumns.activeStatusChip]: 'Active',
  [tokens.settings.apiKey.tableColumns.expiredStatusChip]: 'Expired',
  [tokens.settings.apiKey.deleteToastSuccess]: 'Token deleted successfully.',
  [tokens.settings.apiKey.baseDialog.name]: 'Name',
  [tokens.settings.apiKey.baseDialog.namePlaceholder]: 'Ex: My Token',
  [tokens.settings.apiKey.baseDialog.selectExpirationDate]: 'Select the token expiration date',
  [tokens.settings.apiKey.baseDialog.associatedGroups]: 'Associated Groups',
  [tokens.settings.apiKey.baseDialog.associatedGroupsTooltip]: 'Associate groups so the token automatically inherits their permissions and has access to the selected groups\' folders, complementing the individual permissions defined above.',
  [tokens.settings.apiKey.baseDialog.selectGroups]: 'Select groups',
  [tokens.settings.apiKey.baseDialog.allowedFolders]: 'Allowed Folders',
  [tokens.sidebar.section.general]: 'General',
  [tokens.sidebar.section.other]: 'Other',
  [tokens.sidebar.dashboard]: 'Dashboard',
  [tokens.sidebar.workstation]: 'Workstation',
  [tokens.sidebar.files.title]: 'Files',
  [tokens.sidebar.files.search]: 'Search',
  [tokens.sidebar.files.myFolders]: 'My folders',
  [tokens.sidebar.integrations]: 'Integrations',
  [tokens.sidebar.settings]: 'Settings',
  [tokens.sidebar.members]: 'Members',
  [tokens.sidebar.groups]: 'Groups',
  [tokens.sidebar.appearance]: 'Appearance',
  [tokens.sidebar.billing]: 'Billing',
  [tokens.sidebar.usage]: 'Usage',
  [tokens.sidebar.helpcenter]: 'Help Center',
  [tokens.sidebar.statusPage]: 'Status page',
  [tokens.sidebar.documentation]: 'Docs',
  [tokens.ui.textEditor.toolbar.undo]: 'Undo',
  [tokens.ui.textEditor.toolbar.redo]: 'Redo',
  [tokens.ui.textEditor.toolbar.fullscreen]: 'Fullscreen',
  [tokens.ui.textEditor.toolbar.exitFullscreen]: 'Exit fullscreen',
  [tokens.ui.textEditor.stats.characters]: 'Characters',
  [tokens.ui.textEditor.stats.minimum]: 'Minimum',
  [tokens.ui.textEditor.readOnly]: 'Read only',
  [tokens.ui.selectlanguage]: 'Select language',
  [tokens.ui.common.searchInput]: 'Search',
  [tokens.ui.common.pagination.pageOf]: 'Page {{current}} of {{total}}',
  [tokens.ui.common.datetime.days]: '{{count}} day',
  [tokens.ui.common.datetime.days_other]: '{{count}} days',
  [tokens.ui.common.comingSoon]: 'Coming soon',
  [tokens.ui.common.selectDatePeriod]: 'Select date period',
  [tokens.ui.common.calendar]: 'Calendar',
  [tokens.ui.common.periods]: 'Periods',
  [tokens.ui.common.apply]: 'Apply',
  [tokens.ui.common.warning]: 'Warning',
  [tokens.ui.common.removeMemberWarning]: 'Removing this member will remove all permissions associated with this member.',
  [tokens.ui.common.removeMember]: 'Remove member',
  [tokens.ui.common.noResultsFound]: 'No results found.',
  [tokens.ui.common.noOptionsFound]: 'No options found.',
  [tokens.ui.common.search]: 'Search...',
  [tokens.ui.common.page]: 'Page',
  [tokens.ui.common.history]: 'History',
  [tokens.ui.common.consumption]: 'Consumption',
  [tokens.ui.common.date]: 'Date',
  [tokens.ui.common.quantity]: 'Quantity',
  [tokens.ui.common.noRecordsFound]: 'No records found.',
  [tokens.ui.feature.underDevelopment]: 'This feature is currently under development and will be available soon.',
  [tokens.ui.date.predefinedPeriods]: 'Predefined periods',
  [tokens.ui.date.today]: 'Today',
  [tokens.ui.date.yesterday]: 'Yesterday',
  [tokens.ui.date.last7Days]: 'Last 7 days',
  [tokens.ui.date.last30Days]: 'Last 30 days',
  [tokens.ui.date.currentMonth]: 'Current month',
  [tokens.ui.date.lastMonth]: 'Last month',
  [tokens.ui.date.currentYear]: 'Current year',
  [tokens.ui.auth.logout]: 'Log out',
  [tokens.ui.input.placeholder.command]: 'Type a command or search...',
  [tokens.ui.theme.light]: 'Light',
  [tokens.ui.theme.dark]: 'Dark',
  [tokens.ui.theme.system]: 'System',
  [tokens.ui.confirmation.DoYouConfirmThisAction]: 'Do you confirm this action?',
  [tokens.ui.confirmation.areYouSure]: 'Are you sure?',
  [tokens.ui.confirmation.cannotBeUndone]: 'This action cannot be undone. You confirm the deletion?',
  [tokens.ui.confirmation.nodeDeleteWarning]: 'Deleting this node will permanently erase its data. This action is final. Proceed?',
  [tokens.ui.actions.start]: 'Start',
  [tokens.ui.actions.stop]: 'Stop',
  [tokens.ui.actions.back]: 'Back',
  [tokens.ui.actions.create]: 'Create',
  [tokens.ui.actions.cancel]: 'Cancel',
  [tokens.ui.actions.delete]: 'Delete',
  [tokens.ui.actions.deleteAll]: 'Delete all',
  [tokens.ui.actions.update]: 'Update',
  [tokens.ui.actions.continue]: 'Continue',
  [tokens.ui.actions.save]: 'Save',
  [tokens.ui.actions.saving]: 'Saving...',
  [tokens.ui.actions.ask]: 'Ask',
  [tokens.ui.table.rowsSelected]: '{{count}} of {{total}} row(s) selected.',
  [tokens.ui.common.sort.asc]: 'Ascending',
  [tokens.ui.common.sort.desc]: 'Descending',
  [tokens.ui.common.loading]: 'Loading...',
  [tokens.ui.common.enabled]: 'enabled',
  [tokens.ui.common.disabled]: 'disabled',
  [tokens.ui.common.of]: 'of',
  [tokens.ui.common.delete]: 'Delete',
  [tokens.ui.common.view]: 'View',
  [tokens.ui.common.edit]: 'Edit',
  [tokens.ui.common.selectConversation]: 'Select a conversation',
  [tokens.ui.page.notCreated]: 'This page has not been created yet.',
  [tokens.ui.page.stayTuned]: 'Stay tuned though!',
  [tokens.ui.toasts.organization.switch_success]: 'Organization switched successfully!',
  [tokens.ui.toasts.team.delete_active_error]: 'Cannot delete active team',
  [tokens.ui.toasts.form.submit_values]: 'You submitted the following values:',
  [tokens.ui.toasts.auth.sign_in_now]: 'You should now be able to sign in.',
  [tokens.ui.toasts.user.deleted]: 'The following user has been deleted:',
  [tokens.ui.toasts.file.upload_success]: 'File uploaded',
  [tokens.ui.toasts.file.uploaded_successfully]: 'Your file has been successfully uploaded.',
  [tokens.ui.toasts.folder.create_success]: 'The folder has been created successfully',
  [tokens.ui.toasts.folder.created.description]: 'The folder has been created successfully',
  [tokens.ui.toasts.file.delete_success]: 'Files deleted successfully',
  [tokens.ui.toasts.template.delete_success]: 'Templates deleted successfully',
  [tokens.ui.toasts.folder.delete_success]: 'Folders deleted successfully',
  [tokens.ui.toasts.organization.invite_failed]: 'Failed to accept organization invite',
  [tokens.ui.toasts.organization.invite_accepted.title]: 'Organization invite accepted',
  [tokens.ui.toasts.organization.invite_accepted.description]: 'You are now a member of the organization {{organizationName}}',
  [tokens.ui.toasts.organization.create_success]: 'Organization created successfully!',
  [tokens.ui.toasts.organization.create_error]: 'Error creating organization',
  [tokens.ui.toasts.organization.delete_failed]: 'Failed to delete organization',
  [tokens.ui.toasts.subscription.failed]: 'Unable to complete subscription. Please try again later.',
  [tokens.ui.toasts.sales.contact]: 'Our sales team will contact you shortly!',
  [tokens.ui.toasts.autorecharge.enabled]: 'Auto recharge enabled',
  [tokens.ui.toasts.autorecharge.disabled]: 'Auto recharge disabled',
  [tokens.ui.toasts.autorecharge.status]: 'Auto recharge has been ${checked ? \'enabled\' : \'disabled\'}',
  [tokens.ui.toasts.error.title]: 'Error',
  [tokens.ui.toasts.error.forbidden]: 'You do not have permission to perform this action.',
  [tokens.ui.moduleAccessDenied.title]: 'Feature Unavailable',
  [tokens.ui.moduleAccessDenied.description]:
    'Your organization no longer has access to this feature. Contact your organization administrator for more information.',
  [tokens.ui.moduleAccessDenied.cta]: 'OK',
  [tokens.ui.toasts.payment.default_method_error]: 'Ensure that a default payment method is set.',
  [tokens.ui.toasts.autorecharge.update_failed]: 'Failed to update auto recharge status',
  [tokens.ui.toasts.autorecharge.update_success.title]: 'Auto recharge settings updated',
  [tokens.ui.toasts.autorecharge.update_success.description]: 'Your auto recharge settings have been updated successfully.',
  [tokens.ui.toasts.autorecharge.update_settings_failed]: 'Failed to update auto recharge settings',
  [tokens.ui.toasts.autorecharge.status]: 'Auto recharge has been {{status}}',
  [tokens.ui.toasts.amount.invalid]: 'Invalid amount',
  [tokens.ui.toasts.amount.enter_valid]: 'Please enter a valid amount greater than 0',
  [tokens.ui.toasts.credit.purchase_failed]: 'Failed to process credit purchase',
  [tokens.ui.toasts.group.create_success]: 'Group created successfully!',
  [tokens.ui.toasts.group.update_success]: 'Group updated successfully!',
  [tokens.ui.toasts.group.delete_success]: 'Group deleted successfully!',
  [tokens.ui.toasts.group.create_error.title]: 'Error creating group',
  [tokens.ui.toasts.group.create_error.description]: 'An error occurred while creating the group. Please try again.',
  [tokens.ui.toasts.group.update_error.title]: 'Error updating group',
  [tokens.ui.toasts.group.update_error.description]: 'An error occurred while updating the group. Please try again.',
  [tokens.ui.toasts.group.delete_error.title]: 'Error deleting group',
  [tokens.ui.toasts.group.delete_error.description]: 'An error occurred while deleting the group. Please try again.',
  [tokens.ui.toasts.member.invite_success]: 'Member invited successfully!',
  [tokens.ui.toasts.member.removed_success]: 'Member removed successfully!',
  [tokens.ui.toasts.member.invite_error.title]: 'Error inviting member',
  [tokens.ui.toasts.member.invite_error.description]: 'An error occurred while inviting the member. Please try again.',
  [tokens.ui.toasts.member.remove_error.title]: 'Error removing member',
  [tokens.ui.toasts.member.remove_error.description]: 'An error occurred while removing the member. Please try again.',
  [tokens.ui.toasts.request.review]: 'We will review your request and get back to you as soon as possible.',
  [tokens.ui.toasts.request.failed]: 'Failed to send request',
  [tokens.ui.toasts.task.deleted]: 'The following task has been deleted:',
  [tokens.ui.toasts.file.imported]: 'You have imported the following file:',
  [tokens.ui.toasts.error.generic]: 'An unexpected error has occurred, please wait a few moments and try again!',
  [tokens.ui.toasts.account.created_successfully.title]: 'Account created successfully',
  [tokens.ui.toasts.account.created_successfully.description]: 'You should now be able to sign in',
  [tokens.ui.toasts.common.try_again_later]: 'Please try again later',
  [tokens.ui.toasts.request.received]: 'Request received',
  [tokens.ui.toasts.request.send_success.title]: 'Request sent successfully',
  [tokens.ui.toasts.auth.login_error.title]: 'Login failed',
  [tokens.ui.toasts.folder.delete_error.title]: 'Error deleting folder',
  [tokens.ui.toasts.folder.delete_error.description]: 'An error occurred while deleting the folder. Please try again.',
  [tokens.ui.toasts.folder.create_error.title]: 'Error creating folder',
  [tokens.ui.toasts.folder.create_error.description]: 'An error occurred while creating the folder. Please try again.',
  [tokens.ui.toasts.folder.update_error.title]: 'Error updating folder',
  [tokens.ui.toasts.folder.update_error.description]: 'An error occurred while updating the folder. Please try again.',
  [tokens.ui.toasts.folder.delete_error_plural.title]: 'Error deleting folders',
  [tokens.ui.toasts.folder.delete_error_plural.description]: 'An error occurred while deleting the folders. Please try again.',
  [tokens.ui.toasts.file.delete_error.title]: 'Error deleting files',
  [tokens.ui.toasts.file.delete_error.description]: 'An error occurred while deleting the files. Please try again.',
  [tokens.ui.toasts.generic_error.title]: 'An error occurred',
  [tokens.ui.toasts.generic_error.default_message]: 'An error occurred while performing the operation. Please try again.',
  [tokens.ui.auth.login.subtitle]: 'Enter your email and password below',
  [tokens.ui.auth.login.description]: 'to log into your account',
  [tokens.ui.auth.login.agreement.prefix]: 'By clicking login, you agree to our',
  [tokens.ui.auth.login.agreement.terms]: 'Terms of Service',
  [tokens.ui.auth.login.agreement.privacy]: 'Privacy Policy',
  [tokens.ui.auth.login.agreement.and]: 'e',
  [tokens.ui.auth.login.forgot]: 'Forgot password?',
  [tokens.ui.auth.login.password]: 'Password',
  [tokens.ui.auth.login.no_account]: 'Don\'t have an account?',
  [tokens.ui.auth.login.signup]: 'Sign up',
  [tokens.ui.auth.login.or_continue]: 'Or continue with',
  [tokens.ui.auth.signup.title]: 'Create an account',
  [tokens.ui.auth.signup.confirmPassword]: 'Confirm Password',
  [tokens.ui.auth.signup.subtitle]: 'Enter your email and password to create an account.',
  [tokens.ui.auth.signup.already]: 'Already have an account?',
  [tokens.ui.auth.signup.signin]: 'Sign In',
  [tokens.ui.auth.forgot.title]: 'Forgot Password',
  [tokens.ui.auth.forgot.email]: 'Email',
  [tokens.ui.auth.forgot.enter_registered_email]: 'Enter your registered email',
  [tokens.ui.auth.forgot.send_password_link]: 'and we will send you a link to reset your password.',
  [tokens.ui.auth.forgot.submit]: 'Send password reset link',
  [tokens.ui.auth.forgot.signup]: 'Don\'t have an account?',
  [tokens.ui.auth.forgot.signup_link]: 'Sign up',
  [tokens.ui.folderMultiSelect.selectAll]: 'Select all',
  [tokens.ui.folderMultiSelect.unselectAll]: 'Unselect al',
  [tokens.ui.folderMultiSelect.defaultPlaceholder]: 'Select folders',
  [tokens.plans.community]: 'Community',
  [tokens.plans.commercial]: 'Commercial',
  [tokens.plans.enterprise]: 'Enterprise',
  [tokens.landing.knowledge_management]: 'Knowledge Management',
  [tokens.landing.optimize_knowledge]: 'Optimize knowledge management',
  [tokens.landing.knowledge_management_description]: 'Effective knowledge management is essential to boost productivity, enhance collaboration, and accelerate innovation within an organization.',
  [tokens.landing.work_ai_agent]: 'Work AI Agent',
  [tokens.landing.custom_solutions]: 'Custom Solutions',
  [tokens.landing.custom_solutions_description]: 'Our customized solutions are designed to meet your company’s unique needs, ensuring every implementation is optimized for your success.',
  [tokens.landing.integrations_description]: 'Our AI platform is designed to offer seamless integrations with the leading tools in the market. This allows you to connect your systems and optimize processes effortlessly. We ensure compatibility with a wide range of solutions to meet your specific needs.',
  [tokens.landing.smart_agents_description]: 'Develop interactive agents that provide quick and accurate responses, enhancing experience and automating processes.',
  [tokens.landing.resources]: 'Resources',
  [tokens.landing.blog]: 'Blog',
  [tokens.landing.login]: 'Log In',
  [tokens.landing.get_demo]: 'Start',
  [tokens.landing.description]: 'Find any information from your company in seconds — even if it\'s in PDFs, spreadsheets, videos, or images. Alan interprets, organizes everything, enables fast searches, and automates tasks. No code. No hassle.',
  [tokens.landing.start_now]: 'Start now',
  [tokens.landing.automotive_chip]: 'Automotive',
  [tokens.landing.automotive_title]: 'AI Solution Applied to the Lifecycle of Automotive Products',
  [tokens.landing.machinery_equipment_chip]: 'Machinery and Equipment',
  [tokens.landing.machinery_equipment_title]: 'AI Solution for Product and Machinery Lifecycle Analysis',
  [tokens.landing.media_communication_chip]: 'Media and Communication',
  [tokens.landing.media_communication_title]: 'Artificial Intelligence for Economic Analysis',
  [tokens.landing.aviation_chip]: 'Aviation',
  [tokens.landing.aviation_title]: 'Solution for technical knowledge retrieval in complex maintenance and support environments',
  [tokens.landing.get_in_touch]: 'Get in Touch',
  [tokens.landing.ai_leader]: 'Leading AI research and development, delivering pre-developed and tailored solutions across all industries.',
  [tokens.landing.ai_solutions_and_research]: 'AI and research solutions',
  [tokens.landing.transformation_examples]: 'Transformation Examples with Our Clients:',
  [tokens.landing.tool_integrations]: 'Tool Integrations',
  [tokens.landing.realtime_metrics_chip]: 'Realtime Metrics',
  [tokens.landing.realtime_metrics_title]: 'Monitor data and performance instantly',
  [tokens.landing.smart_agents]: 'Smart and interactive agents',
  [tokens.landing.tailored_solutions]: 'Tailored solutions for your business',
  [tokens.landing.integrations_with_your_tools]: 'Integrations with your tools',
  [tokens.landing.who_trust_us]: 'Who trusts us',
  [tokens.landing.who_already_uses]: 'Who already uses',
  [tokens.landing.simplify_ai]: 'Simplify AI implementation',
  [tokens.landing.in_enterprise]: 'in the business world',
  [tokens.landing.full_platform]: 'Complete platform to integrate, develop, and manage AI solutions with security and scalability',
  [tokens.landing.prompt_library]: 'Prompt Library',
  [tokens.landing.reuse_prompts]: 'Reuse and share effective prompts',
  [tokens.landing.smart_search]: 'Smart Search',
  [tokens.landing.find_info_ai]: 'Find any information in seconds with AI-powered search',
  [tokens.landing.business_chat]: 'Business Chat',
  [tokens.landing.natural_chat_interface]: 'Interact with your data through a natural conversational interface',
  [tokens.landing.autonomous_agents]: 'Autonomous Agents',
  [tokens.landing.create_no_code_agents]: 'Create no-code AI assistants that automate complex tasks',
  [tokens.landing.enterprise_ai_platform]: 'Enterprise AI Platform',
  [tokens.landing.full_architecture]: 'Complete architecture for secure and scalable implementation',
  [tokens.landing.genai_foundation]: 'GenAI Foundation',
  [tokens.landing.multi_llm]: 'Multi-LLM',
  [tokens.landing.multi_llm_access]: 'Access to multiple language models',
  [tokens.landing.rag_engine]: 'RAG',
  [tokens.landing.rag_description]: '"Ask an unlimited volume of information and get dynamic, reliable answers"',
  [tokens.landing.memory]: 'Memory',
  [tokens.landing.dynamic_learning]: '"Dynamic, automatic learning as you interact"',
  [tokens.landing.intelligence_layer]: 'Intelligence Layer',
  [tokens.landing.knowledge_graph]: 'Knowledge Graph',
  [tokens.landing.knowledge_mapping]: 'Mapping of data relationships',
  [tokens.landing.hybrid_search]: 'Hybrid Search',
  [tokens.landing.hybrid_search_description]: 'Combination of vector and semantic search',
  [tokens.landing.self_learning]: 'Self-learning',
  [tokens.landing.self_learning_description]: 'Models that improve with use',
  [tokens.landing.security_governance]: 'Security & Governance',
  [tokens.landing.real_time_permissions]: 'Real-time Permissions',
  [tokens.landing.access_control]: 'Granular access control',
  [tokens.landing.content_policies]: 'Content Policies',
  [tokens.landing.content_filtering]: 'Automatic filtering and moderation',
  [tokens.landing.continuous_audit]: 'Continuous Auditing',
  [tokens.landing.audit_monitoring]: 'Usage and compliance monitoring',
  [tokens.landing.full_ecosystem]: 'Complete Ecosystem',
  [tokens.landing.connect_tools]: 'Connect with your existing tools and infrastructure',
  [tokens.landing.data_sources]: 'Your data sources',
  [tokens.landing.connect_all_tools]: 'Connect to all your tools',
  [tokens.landing.engineering]: 'Engineering',
  [tokens.landing.collaboration]: 'Collaboration',
  [tokens.landing.documents]: 'Documents',
  [tokens.landing.businesses]: 'Business',
  [tokens.landing.infrastructure]: 'Your infrastructure',
  [tokens.landing.start_ai_today]: 'Start your AI journey today',
  [tokens.landing.transform_with_ai]: 'Transform your business with secure, scalable, and easy-to-implement AI solutions',
  [tokens.landing.security_and_governance]: 'Security and Governance',
  [tokens.landing.how_we_protect_data]: 'How do we protect your data?',
  [tokens.landing.data_protection]: 'We use advanced encryption and international security standards to ensure your data is always protected.',
  [tokens.landing.compliance_check]: 'Are we compliant with security standards?',
  [tokens.landing.compliance_answer]: 'Yes, we follow market best practices and comply with GDPR, LGPD, and other global standards.',
  [tokens.landing.data_access]: 'Who has access to your information?',
  [tokens.landing.data_access_answer]: 'Only authorized users and properly authenticated systems can access your information, with detailed audit logs.',
  [tokens.landing.hero_title]: 'Alan – your AI for agile work',
  [tokens.landing.hero_subtitle]: 'Boost your team\'s productivity with an intelligent intranet.',
  [tokens.landing.contact_us_cta]: 'Contact us',
  [tokens.landing.contact_us_text]: 'We\'re here to help with your AI needs',
  [tokens.landing.find_us]: 'Find us',
  [tokens.landing.copyright]: '2025 Mr. Turing AI - All rights reserved',
  [tokens.landing.terms]: 'Terms and Conditions',
  [tokens.landing.privacy]: 'Privacy Policy',
  [tokens.landing.enterprise_cta]: 'Need a plan for your company? Discover Enterprise. Get in touch!',
  [tokens.landing.contact_button]: 'Contact us',
  [tokens.landing.community_text]: 'An exclusive network focused on support and collaboration.',
  [tokens.landing.community_title]: 'Alan Community Network',
  [tokens.landing.slack_community_description]: 'Join our Slack community: ask questions, share suggestions, and collaborate in a space for learning and exchange.',
  [tokens.landing.support_title]: 'Support',
  [tokens.landing.support_description]: 'Our support system is always ready to help you solve any issue quickly and efficiently.',
  [tokens.landing.get_started_cta]: 'Ready to get started?',
  [tokens.landing.explore_prompts]: 'Explore your organization\'s prompts...',
  [tokens.landing.documentation_title]: 'Documentations',
  [tokens.landing.documentation_description]: 'Learn more about Alan\'s documentation',
  [tokens.landing.community_title]: 'Community',
  [tokens.landing.community_description]: 'Join the Alan community',
  [tokens.landing.latest_posts_title]: 'Latest Posts',
  [tokens.landing.latest_posts_description]: 'Check out the latest blog posts',
  [tokens.landing.recent_updates_title]: 'Recent Updates',
  [tokens.landing.recent_updates_description]: 'See the latest news and updates',
  [tokens.landing.schedule_demo]: 'Schedule a demo',
  [tokens.landing.security_note]: 'Our enterprise-grade security keeps your data protected at all times',
  [tokens.landing.automotive_description]: 'An AI solution for analyzing the lifecycle of automotive products, combining NLP, LLMs, computer vision, data mining, and cloud computing. It delivers strategic, data-driven insights and identifies the ideal timing and minimum investment to stay competitive based on accurate market analysis.',
  [tokens.landing.machinery_equipment_description]: 'We developed an AI solution for CNH Industrial to analyze the lifecycle of products and machinery, using NLP, LLMs, computer vision, and data mining.It provides insights on the ideal timing and investment to remain competitive.The solution now also works offline, bringing innovation to rural areas and remote operations.',
  [tokens.landing.media_communication_description]: 'ConfIA is an AI solution that delivers reliable, contextual answers about the economy and regional indicators. It understands both text and charts, ensuring accurate and accessible information. This innovative project advances the spread of regional economic data, aligned with our mission to democratize access to information.',
  [tokens.landing.realtime_metrics_description]: 'With Alan, you can monitor employee engagement and encourage strategic use of AI. Track rankings, usage metrics, and interactions to provide continuous feedback and foster a collaborative, productive environment aligned with your company’s goals.',
  [tokens.landing.advanced_semantic_search]: 'Advanced semantic search',
  [tokens.landing.contextual_answers]: 'Contextualized answers',
  [tokens.landing.intelligent_automation]: 'Intelligent automation',
  [tokens.landing.login]: 'Log In',
  [tokens.landing.send]: 'Send',
  [tokens.landing.flexible_ready]: 'Flexible and ready for any environment',
  [tokens.landing.form_response_success]: 'Message sent',
  [tokens.landing.form_response_title]: 'Form submitted',
  [tokens.landing.name_required]: 'Name is required',
  [tokens.landing.email_required]: 'Email is required',
  [tokens.landing.invalid_email]: 'Invalid email format',
  [tokens.landing.required_field]: '*Required',
  [tokens.landing.form_response_error]: 'Failed to send message',
  [tokens.landing.api_documentation]: 'API Documentation',
  [tokens.landing.join_slack]: 'Join Slack',
  [tokens.landing.platform]: 'Platform',
  [tokens.landing.see_documentation]: 'See the documentation',
  [tokens.files.integration.status.disconnected]: 'Disconnected',
  [tokens.files.integration.status.connected]: 'Connected',
  [tokens.files.integration.action.disconnected]: 'Configure integration',
  [tokens.files.integration.action.connected]: 'Select folders',
  [tokens.files.integration.action.syncFolders]: 'Folders synced successfully',
  [tokens.files.integration.selectFolders.header]: 'Select folders to sync',
  [tokens.files.integration.selectFolders.selectAllFolders]: 'Select all folders',
  [tokens.files.integration.selectFolders.noFolders.googledrive]: 'No folders found in your Google Drive',
  [tokens.files.integration.selectFolders.noFolders.onedrive]: 'No folders found in your OneDrive',
  [tokens.files.integration.selectFolders.noFolders.sharepoint]: 'No folders found in your SharePoint site',
  [tokens.files.integration.selectFolders.noFolders.sharepointSites]: 'No sites found in your SharePoint',
  [tokens.ui.common.action.connect]: 'Connect',
  [tokens.ui.common.action.disconnect]: 'Disconnect',
  [tokens.ui.common.action.improve]: 'To improve',
  [tokens.dashboard.chatHistoryTable.feedbackFilter.all]: 'All feedback',
  [tokens.dashboard.chatHistoryTable.feedbackFilter.positive]: 'Positive',
  [tokens.dashboard.chatHistoryTable.feedbackFilter.negative]: 'Negative',
  [tokens.dashboard.chatHistoryTable.feedbackFilter.none]: 'No feedback',
  [tokens.dashboard.chatHistoryTable.feedbackFilter.label]: 'Filter feedback by type',
  [tokens.dashboard.chatHistoryTable.feedback.positive.label]: 'Positive feedback',
  [tokens.dashboard.chatHistoryTable.feedback.negative.label]: 'Negative feedback',
  [tokens.dashboard.chatHistoryTable.metadataFilter.title]: 'Metadata',
  [tokens.dashboard.chatHistoryTable.metadataFilter.subtitle]: 'Metadata Filters',
  [tokens.dashboard.chatHistoryTable.metadataFilter.addFilter]: 'Add Filter',
  [tokens.dashboard.chatHistoryTable.metadataFilter.supportedTypes]: 'Supported Types',
  [tokens.dashboard.chatHistoryTable.metadataFilter.typeText]: 'Text: any string',
  [tokens.dashboard.chatHistoryTable.metadataFilter.typeNumber]: 'Number: 123, 45.67',
  [tokens.dashboard.chatHistoryTable.metadataFilter.typeBoolean]: 'Boolean: true, false',
  [tokens.dashboard.chatHistoryTable.metadataFilter.typeNull]: 'Null: null',
  [tokens.dashboard.chatHistoryTable.metadataFilter.key]: 'Key',
  [tokens.dashboard.chatHistoryTable.metadataFilter.value]: 'Value',
  [tokens.workstation.feedbackModal.suggestedReasons.incorrect]: 'It\'s incorrect',
  [tokens.workstation.feedbackModal.suggestedReasons.outdated]: 'It contains outdated information',
  [tokens.workstation.feedbackModal.suggestedReasons.invented]: 'It made up information',
  [tokens.workstation.feedbackModal.suggestedReasons.irrelevant]: 'It\'s irrelevant',
  [tokens.workstation.feedbackModal.suggestedReasons.ignored]: 'It ignored an important part of the question',
  [tokens.workstation.feedbackModal.suggestedReasons.generic]: 'It\'s too generic',
  [tokens.workstation.feedbackModal.suggestedReasons.shallow]: 'It\'s shallow / lacks depth',
  [tokens.workstation.feedbackModal.suggestedReasons.confusing]: 'It\'s confusing or hard to understand',
  [tokens.workstation.feedbackModal.suggestedReasons.tooTechnical]: 'It\'s too technical',
  [tokens.workstation.feedbackModal.suggestedReasons.redundant]: 'It\'s redundant',
  [tokens.workstation.feedbackModal.suggestedReasons.biased]: 'It seems biased',
  [tokens.workstation.feedbackModal.suggestedReasons.title]: 'Why wasn\'t it helpful?',
  [tokens.workstation.feedbackModal.input.placeholder]: 'Describe what wasn\'t helpful or what could be improved (optional)',
  [tokens.workstation.feedbackModal.cancel]: 'Cancel',
  [tokens.workstation.feedbackModal.sendFeedback]: 'Send feedback',
  [tokens.workstation.feedbackModal.thankYouFeedback]: 'Thank you for the feedback!',
  [tokens.fileSearch.graph.noResults]: 'No results found',
  [tokens.fileSearch.nodeMenu.basicInfo]: 'Basic Information',
  [tokens.fileSearch.nodeMenu.totalFiles]: 'Total Files',
  [tokens.fileSearch.nodeMenu.totalSize]: 'Total Size',
  [tokens.fileSearch.nodeMenu.category]: 'Category',
  [tokens.fileSearch.nodeMenu.creationDate]: 'Creation Date',
  [tokens.fileSearch.nodeMenu.visibility]: 'Visibility',
  [tokens.fileSearch.nodeMenu.public]: 'Public',
  [tokens.fileSearch.nodeMenu.private]: 'Private',
  [tokens.fileSearch.nodeMenu.accessPermissions]: 'Access Permissions',
  [tokens.fileSearch.nodeMenu.extension]: 'Extension',
  [tokens.fileSearch.nodeMenu.size]: 'Size',
  [tokens.fileSearch.loading.message]: 'Buildding neural graph...',
  [tokens.fileSearch.sidebar.fileSearch]: 'File search',
  [tokens.fileSearch.nodeMenu.processingStatus]: 'Processing status',
  [tokens.fileSearch.graph.searchTextLoadScreen]: 'I\'m processing the data, this may take a few seconds...',
  [tokens.blog.title.whatsNew]: 'What\'s new?',
  [tokens.blog.section.moreContent]: 'More content',
  [tokens.blog.navigation.back]: 'Back',
  [tokens.blog.navigation.viewAllPosts]: 'View all posts',
  [tokens.blog.navigation.backToBlog]: 'Back to Blog',
  [tokens.blog.search.placeholder]: 'Type to search...',
  [tokens.blog.search.resultsFor]: 'Results for',
  [tokens.blog.search.resultCount.singular]: 'post found',
  [tokens.blog.search.resultCount.plural]: 'posts found',
  [tokens.blog.loading.posts]: 'Loading posts...',
  [tokens.blog.loading.singlePost]: 'Loading post...',
  [tokens.blog.error.loadPosts.title]: 'Error loading posts',
  [tokens.blog.error.loadPosts.description]: 'An error occurred while loading blog posts. Please try again later.',
  [tokens.blog.empty.noPosts.title]: 'No posts found',
  [tokens.blog.empty.noPosts.searchDescription]: 'Try adjusting your search terms to find posts.',
  [tokens.blog.empty.noPosts.generalDescription]: 'No posts have been published to the blog yet.',
  [tokens.blog.notFound.title]: 'Post not found',
  [tokens.blog.notFound.noSlug]: 'Post slug was not provided in the URL.',
  [tokens.blog.notFound.description]: 'The post you are looking for does not exist or has been removed.',
  [tokens.blog.post.readingTime.unit]: 'min',
  [tokens.blog.post.readingTime.full]: 'min read',
  [tokens.blog.post.author.by]: 'By',
  [tokens.blog.post.author.unknown]: 'Unknown author',
  [tokens.blog.pagination.previous]: 'Previous',
  [tokens.blog.pagination.next]: 'Next',
  [tokens.blog.date.notAvailable]: 'Date not available',
  [tokens.blog.date.invalid]: 'Invalid date',
  [tokens.blog.content.titleNotAvailable]: 'Title not available',
  [tokens.blog.content.contentNotAvailable]: 'Content not available',
  [tokens.blog.content.defaultImageAlt]: 'Blog post',
  [tokens.blog.external.documentation]: 'Documentation',
  [tokens.blog.external.apiStatus]: 'API Status',
  [tokens.blog.accessibility.backToBlog]: 'Back to Blog',
  [tokens.notifications.platform.title]: 'Notifications',
  [tokens.notifications.platform.empty.title]: 'No notifications',
  [tokens.notifications.platform.empty.description]: 'You have no notifications at the moment. When there are important updates they will appear here.',
  [tokens.notifications.releaseNotes.title]: 'Release Notes',
  [tokens.notifications.releaseNotes.tooltip]: 'Release Notes',
  [tokens.notifications.releaseNotes.empty.title]: 'No updates available',
  [tokens.notifications.releaseNotes.empty.description]: 'There are no new updates or release notes to display at the moment. Come back later to see the latest news!',
  [tokens.notifications.common.markAsRead]: 'Mark as read',
  [tokens.notifications.common.loading]: 'Loading...',
  [tokens.notifications.common.error.fetch]: 'Failed to fetch notifications',
  [tokens.notifications.common.error.markAsRead]: 'Failed to mark notification as read',
  [tokens.notifications.common.markAllAsRead]: 'Mark all as read',
  [tokens.aihub.gatewayTitle]: 'AI Hub',
  [tokens.aihub.gatewaySubtitle]: 'Manage your agents and assistants',
  [tokens.aihub.gatewayNewFlow]: 'New flow',
  [tokens.aihub.gatewaySearchPlaceholder]: 'Search in AI hub...',
  [tokens.aihub.gatewayItemsShowing]: 'Showing {{count}} of {{total}} items',
  [tokens.aihub.gatewayNoResultsSearch]: 'No results found',
  [tokens.aihub.gatewayNoResultsAgents]: 'No agents found',
  [tokens.aihub.gatewayNoResultsAssistants]: 'No assistants found',
  [tokens.aihub.gatewayNoResultsGeneral]: 'No AI solutions found',
  [tokens.aihub.gatewayLoadMore]: 'Show more',
  [tokens.aihub.gatewayLoading]: 'Loading...',
  [tokens.aihub.gatewayDeleteConfirm]: 'Are you sure you want to delete this {{type}}? This action cannot be undone.',
  [tokens.aihub.gatewayDeleteAgent]: 'agent',
  [tokens.aihub.gatewayDeleteAssistant]: 'assistant',
  [tokens.aihub.gatewayDeleteAction]: 'Delete',
  [tokens.aihub.gatewayCreateTitle]: 'How would you like to proceed?',
  [tokens.aihub.gatewayCreateProcessFlow]: 'Process flow',
  [tokens.aihub.gatewayCreateProcessFlowDesc]: 'Build an intelligent agent capable of executing and scheduling automated workflows with or without human intervention. Ideal for document processing data analysis and automation of complex processes.',
  [tokens.aihub.gatewayCreateConversationalFlow]: 'Conversational flow',
  [tokens.aihub.gatewayCreateConversationalFlowDesc]: 'Create an intelligent conversational assistant that offers personalized and accurate interactions based on your knowledge sources. Perfect for customer support specialized consulting and contextual assistance.',
  [tokens.aihub.gatewayFilterTitle]: 'Filter',
  [tokens.aihub.gatewayFilterReset]: 'Reset',
  [tokens.aihub.gatewayFilterFlowType]: 'Flow type',
  [tokens.aihub.gatewayFilterAll]: 'All',
  [tokens.aihub.gatewayFilterProcess]: 'Process (Agent)',
  [tokens.aihub.gatewayFilterConversational]: 'Conversational (Assistant)',
  [tokens.aihub.gatewayFilterStatus]: 'Status',
  [tokens.aihub.gatewayFilterActive]: 'Active',
  [tokens.aihub.gatewayFilterInactive]: 'Inactive',
  [tokens.aihub.gatewayFilterApply]: 'Apply',
  [tokens.aihub.gatewayFilterClear]: 'Clear',
  [tokens.aihub.gatewayFilterSoon]: 'Coming soon',
  [tokens.aihub.assistantNotFound]: 'Assistant not found',
  [tokens.aihub.assistantNotFoundDesc]: 'The requested assistant was not found or does not exist.',
  [tokens.aihub.assistantTabsConfigure]: 'Configure',
  [tokens.aihub.assistantTabsPersonalize]: 'Personalize',
  [tokens.aihub.assistantTabsVersions]: 'Manage Versions',
  [tokens.aihub.assistantTabsIntegrate]: 'Integrate',
  [tokens.aihub.assistantTabsPreview]: 'Preview',
  [tokens.aihub.assistantPreviewVersion]: 'Version preview:',
  [tokens.aihub.assistantConfigTitle]: 'Assistant Name *',
  [tokens.aihub.assistantConfigNamePlaceholder]: 'Enter the assistant name',
  [tokens.aihub.assistantConfigDescription]: 'Description',
  [tokens.aihub.assistantConfigDescriptionPlaceholder]: 'Describe the purpose and functionalities of the assistant',
  [tokens.aihub.assistantConfigKnowledgeTitle]: 'Link Knowledge Base',
  [tokens.aihub.assistantConfigKnowledgeEmpty]: 'So far no knowledge base has been linked to the assistant.',
  [tokens.aihub.assistantConfigKnowledgeAdd]: 'Add',
  [tokens.aihub.assistantConfigKnowledgeInclude]: 'Include knowledge base',
  [tokens.aihub.assistantConfigKnowledgeSelectPlaceholder]: 'Select a folder',
  [tokens.aihub.assistantConfigKnowledgeLoading]: 'Loading...',
  [tokens.aihub.assistantConfigKnowledgeInstructionsPlaceholder]: 'Provide guidance on how the assistant should use this knowledge base',
  [tokens.aihub.assistantConfigKnowledgeRemove]: 'Remove knowledge base',
  [tokens.aihub.assistantPersonalizeTitle]: 'Personalization',
  [tokens.aihub.assistantPersonalizeSubtitle]: 'Customize the appearance and behavior of your assistant.',
  [tokens.aihub.assistantPersonalizeAvatar]: 'Avatar',
  [tokens.aihub.assistantPersonalizeUpload]: 'Upload',
  [tokens.aihub.assistantPersonalizeLogoMaxSize]: '1:1 ratio max. 5MB',
  [tokens.aihub.assistantInterfaceTitle]: 'Interface colors',
  [tokens.aihub.assistantInterfaceHeaderBackground]: 'Header background',
  [tokens.aihub.assistantInterfaceHeaderText]: 'Header text',
  [tokens.aihub.assistantInterfaceChatBackground]: 'Chat background',
  [tokens.aihub.assistantInterfaceChatBorder]: 'Chat borders',
  [tokens.aihub.assistantInterfaceUserBalloonBackground]: 'User balloon background',
  [tokens.aihub.assistantInterfaceUserBalloonText]: 'User balloon text',
  [tokens.aihub.assistantInterfaceAgentBalloonBackground]: 'Assistant balloon background',
  [tokens.aihub.assistantInterfaceAgentBalloonText]: 'Assistant balloon text',
  [tokens.aihub.assistantInterfaceInputTextColor]: 'Message text color',
  [tokens.aihub.assistantTypographyTitle]: 'Typography',
  [tokens.aihub.assistantTypographyGreetingMessage]: 'Welcome message',
  [tokens.aihub.assistantTypographyGreetingMessagePlaceholder]: 'Hello! I\'m your virtual assistant.',
  [tokens.aihub.assistantTypographySubtitleMessage]: 'Subtitle message',
  [tokens.aihub.assistantTypographySubtitleMessagePlaceholder]: 'How can I help you today?',
  [tokens.aihub.assistantTypographyPlaceholderMessage]: 'Input placeholder',
  [tokens.aihub.assistantTypographyPlaceholderMessagePlaceholder]: 'Type your message...',
  [tokens.aihub.assistantVersionsTitle]: 'Assistant Versions',
  [tokens.aihub.assistantVersionsSubtitle]: 'Manage your assistant versions and deploy the desired version.',
  [tokens.aihub.assistantVersionsLoading]: 'Loading versions...',
  [tokens.aihub.assistantVersionsEmpty]: 'No versions found for this assistant.',
  [tokens.aihub.assistantVersionsEmptyDescription]: 'Create a version in the settings tab to get started.',
  [tokens.aihub.assistantVersionsTableVersionName]: 'Version Name',
  [tokens.aihub.assistantVersionsTableStatus]: 'Status',
  [tokens.aihub.assistantVersionsTableCreatedAt]: 'Created at',
  [tokens.aihub.assistantVersionsTableDeployedAt]: 'Deployed at',
  [tokens.aihub.assistantVersionsTableDeployed]: 'Deployed',
  [tokens.aihub.assistantVersionsTableSaved]: 'Saved',
  [tokens.aihub.assistantVersionsActionsEdit]: 'Edit',
  [tokens.aihub.assistantVersionsActionsDeploy]: 'Deploy',
  [tokens.aihub.assistantVersionsActionsDeploying]: 'Deploying...',
  [tokens.aihub.assistantVersionsActionsDelete]: 'Delete',
  [tokens.aihub.assistantVersionsActionsOpenMenu]: 'Open menu',
  [tokens.aihub.assistantVersionsDialogDeployTitle]: 'Confirm Deployment',
  [tokens.aihub.assistantVersionsDialogDeployDescription]: 'Are you sure you want to deploy version {{versionName}}? This action will replace the currently deployed version.',
  [tokens.aihub.assistantVersionsDialogDeployConfirm]: 'Deploy',
  [tokens.aihub.assistantVersionsDialogDeleteTitle]: 'Confirm Deletion',
  [tokens.aihub.assistantVersionsDialogDeleteDescription]: 'Are you sure you want to delete version {{versionName}}? This action cannot be undone.',
  [tokens.aihub.confirmationCannotBeUndone]: 'When switching to editing another version, any unsaved changes in the current version will be lost.',
  [tokens.aihub.assistantVersionsDialogDeleteConfirm]: 'Delete',
  [tokens.aihub.assistantIntegrateTitle]: 'Integration',
  [tokens.aihub.assistantIntegrateSubtitle]: 'Configure integrations with other platforms and services.',
  [tokens.aihub.assistantIntegrateWhatsappTitle]: 'WhatsApp',
  [tokens.aihub.assistantIntegrateWhatsappDescription]: 'Add WhatsApp numbers to integrate with your assistant.',
  [tokens.aihub.assistantIntegrateWhatsappPhoneNumber]: 'Phone number',
  [tokens.aihub.assistantIntegrateWhatsappPhoneNumberPlaceholder]: 'Enter the phone number',
  [tokens.aihub.assistantIntegrateWhatsappSearchCountry]: 'Search country...',
  [tokens.aihub.assistantIntegrateWhatsappCountryNotFound]: 'Country not found',
  [tokens.aihub.assistantIntegrateWhatsappAdd]: 'Add',
  [tokens.aihub.assistantIntegrateWhatsappRegisteredNumbers]: 'Registered numbers',
  [tokens.aihub.assistantIntegrateWhatsappEmpty]: 'No WhatsApp numbers registered',
  [tokens.aihub.assistantIntegrateWhatsappEmptyDescription]: 'Add a number to start integrating',
  [tokens.aihub.assistantIntegrateWhatsappStatusValidated]: 'Validated',
  [tokens.aihub.assistantIntegrateWhatsappStatusPending]: 'Waiting for validation',
  [tokens.aihub.assistantIntegrateWhatsappStatusUnknown]: 'Unknown',
  [tokens.aihub.assistantIntegrateIframeTitle]: 'Iframe',
  [tokens.aihub.assistantIntegrateIframeDescription]: 'Integrate the assistant into your application using iframe. Follow the steps below:',
  [tokens.aihub.assistantIntegrateIframeStep1]: 'Step 1: Insert the style and script call code in the head/head section of your application\'s index.html file.',
  [tokens.aihub.assistantIntegrateIframeStep2]: 'Step 2: In this same file within the body/body section insert the assistant embedding code.',
  [tokens.aihub.assistantIntegrateIframeCopyError]: 'Error copying text',
  [tokens.aihub.assistantSaveVersionTitle]: 'Save Version',
  [tokens.aihub.assistantSaveVersionVersionName]: 'Version Name',
  [tokens.aihub.assistantSaveVersionVersionNamePlaceholder]: 'Enter the version name',
  [tokens.aihub.assistantSaveVersionAutoDeploy]: 'Deploy version automatically',
  [tokens.aihub.assistantSaveVersionAutoDeployDescription]: 'When you deploy a release, it\'s instantly applied to your built-in assistants.',
  [tokens.aihub.assistantSaveVersionCancel]: 'Cancel',
  [tokens.aihub.assistantSaveVersionSave]: 'Save Version',
  [tokens.aihub.assistantSaveVersionSaving]: 'Saving...',
  [tokens.aihub.assistantPreviewUnsavedChanges]: 'Unsaved changes',
  [tokens.aihub.assistantPreviewDiscardChanges]: 'Discard changes',
  [tokens.aihub.assistantPreviewSaveVersion]: 'Save version',
  [tokens.aihub.assistantPreviewNewConversation]: 'New chat',
  [tokens.aihub.assistantPreviewLoading]: 'Loading...',
  [tokens.aihub.assistantErrorCreateAgent]: 'Error creating agent',
  [tokens.aihub.assistantErrorCreateAgentDescription]: 'Unable to create agent',
  [tokens.aihub.assistantErrorCreateAssistant]: 'Error creating assistant',
  [tokens.aihub.assistantErrorCreateAssistantDescription]: 'Unable to create assistant',
  [tokens.aihub.validate]: 'Validar',
  [tokens.aihub.whatsappPhoneAlreadyExists]: 'Este número de telefone já foi adicionado',
  [tokens.aihub.whatsappValidationError]: 'Erro ao validar o número do WhatsApp',
  [tokens.aihub.whatsappValidationSuccess]: 'WhatsApp validado com sucesso',
  [tokens.aihub.whatsappValidationTitle]: 'Validação do WhatsApp',
  [tokens.aihub.whatsappValidationDescription]: 'Validando o número {phone}',
  [tokens.aihub.whatsappValidatingPhone]: 'Validando número de telefone...',
  [tokens.aihub.whatsappGeneratingQRCode]: 'Gerando QR Code...',
  [tokens.aihub.whatsappScanQRCode]: 'Escaneie o código QR com o WhatsApp',
  [tokens.aihub.whatsappWaitingForScan]: 'Aguardando escaneamento do código QR...',
  [tokens.aihub.whatsappConnecting]: 'Conectando ao WhatsApp...',
  [tokens.aihub.whatsappAuthenticated]: 'WhatsApp Autenticado',
  [tokens.aihub.whatsappAuthenticatedDescription]: 'Seu WhatsApp foi conectado com sucesso',
  [tokens.aihub.whatsappAuthenticationFailed]: 'Falha na autenticação do WhatsApp',
  [tokens.aihub.whatsappValidationFailed]: 'Falha na Validação',
  [tokens.aihub.whatsappVersionDeployed]: 'Nova versão criada e implantada com o WhatsApp',
  [tokens.aihub.whatsappVersionDeployError]: 'Erro ao criar versão com WhatsApp',
  [tokens.aihub.tryAgain]: 'Tentar Novamente',
  [tokens.aihub.error]: 'Erro',
  [tokens.aihub.success]: 'Sucesso',
  [tokens.aihub.whatsappRemovedSuccessfully]: 'WhatsApp removido com sucesso',
  [tokens.aihub.whatsappRemovalError]: 'Falha ao remover WhatsApp',
  [tokens.aihub.whatsappPhoneAlreadyExists]: 'Este número de telefone já foi adicionado',
  [tokens.aihub.whatsappPhoneAlreadyUsed]: 'Este número do WhatsApp já está conectado a outro assistente',
  [tokens.aihub.whatsappRevalidationRequired]: 'Validação do WhatsApp necessária para esta versão',
  [tokens.aihub.gatewayFilterSelectAuthors]: 'Authors',
  [tokens.aihub.gatewayFilterAuthorsPlaceholder]: 'Select authors to filter...',
  [tokens.aihub.gatewayFilterClearAuthors]: 'Clear authors',
  [tokens.aihub.gatewayFilterMy]: 'My',
  [tokens.aihub.gatewayFilterShared]: 'Shared',
  [tokens.tickets.page.title]: 'Support',
  [tokens.tickets.page.subtitle]: 'Manage your support tickets',
  [tokens.tickets.create.button]: 'Create Ticket',
  [tokens.tickets.search.placeholder]: 'Search tickets...',
  [tokens.tickets.filter.status.placeholder]: 'Filter by status',
  [tokens.tickets.filter.status.all]: 'All statuses',
  [tokens.tickets.filter.status.open]: 'Open',
  [tokens.tickets.filter.status.in_progress]: 'In Progress',
  [tokens.tickets.filter.status.blocked]: 'Blocked',
  [tokens.tickets.filter.status.resolved]: 'Resolved',
  [tokens.tickets.filter.type.placeholder]: 'Filter by type',
  [tokens.tickets.filter.type.all]: 'All types',
  [tokens.tickets.filter.type.technical_problems]: 'Technical Problems',
  [tokens.tickets.filter.type.integration_problems]: 'Integration Problems',
  [tokens.tickets.filter.type.security_issues]: 'Security Issues',
  [tokens.tickets.filter.type.suggestions]: 'Suggestions',
  [tokens.tickets.filter.type.others]: 'Others',
  [tokens.tickets.error.load_title]: 'Error loading tickets',
  [tokens.tickets.error.load_description]: 'An error occurred while loading tickets. Please try again later.',
  [tokens.tickets.empty.title]: 'No tickets found',
  [tokens.tickets.empty.description]: 'There are no tickets to display. Create a new ticket to get started.',
  [tokens.tickets.table.title_column]: 'Ticket title',
  [tokens.tickets.table.type_column]: 'Type',
  [tokens.tickets.table.created_date_column]: 'Created date',
  [tokens.tickets.table.deadline_column]: 'Deadline',
  [tokens.tickets.table.status_column]: 'Status',
  [tokens.tickets.table.actions_column]: 'Actions',
  [tokens.tickets.table.deadline_undefined]: 'Not defined',
  [tokens.tickets.table.deadline_not_estimated]: 'Not yet estimated - wait for your service',
  [tokens.tickets.table.no_results]: 'No results found.',
  [tokens.tickets.table.chat_resolved_tooltip]: 'Ticket resolved - chat not available',
  [tokens.tickets.table.chat_available_tooltip]: 'Chat with support',
  [tokens.tickets.table.evidence_resolved_tooltip]: 'Ticket resolved - cannot send evidence',
  [tokens.tickets.table.evidence_button]: 'Send evidence',
  [tokens.tickets.table.close_resolved_tooltip]: 'Ticket resolved - cannot close',
  [tokens.tickets.table.close_button]: 'Close ticket',
  [tokens.tickets.detail.title_label]: 'Title',
  [tokens.tickets.detail.deadline_label]: 'Deadline',
  [tokens.tickets.detail.description_label]: 'Description',
  [tokens.tickets.detail.attachments_label]: 'Attachments',
  [tokens.tickets.detail.no_attachments]: 'No attachments',
  [tokens.tickets.detail.created_at]: 'Created on',
  [tokens.tickets.detail.deadline_resolution]: 'Resolution Deadline:',
  [tokens.tickets.detail.type_label]: 'Type',
  [tokens.tickets.detail.loading]: 'Loading ticket...',
  [tokens.tickets.detail.error]: 'Error loading ticket',
  [tokens.tickets.create.modal.title]: 'Create New Ticket',
  [tokens.tickets.create.title_label]: 'Title *',
  [tokens.tickets.create.title_placeholder]: 'Enter the ticket title',
  [tokens.tickets.create.type_label]: 'Type *',
  [tokens.tickets.create.type_placeholder]: 'Select type',
  [tokens.tickets.create.description_label]: 'Description *',
  [tokens.tickets.create.description_placeholder]: 'Describe the problem or request in detail',
  [tokens.tickets.create.attachments_label]: 'Attachments',
  [tokens.tickets.create.attachments_drag_text]: 'Drag files here or click to select',
  [tokens.tickets.create.attachments_button]: 'Select Files',
  [tokens.tickets.create.selected_files_label]: 'Selected files:',
  [tokens.tickets.create.cancel_button]: 'Cancel',
  [tokens.tickets.create.submit_button]: 'Create Ticket',
  [tokens.tickets.create.submitting_button]: 'Creating...',
  [tokens.tickets.create.success_title]: 'Ticket created',
  [tokens.tickets.create.success_description]: 'The ticket was created successfully.',
  [tokens.tickets.create.error_title]: 'Error creating ticket',
  [tokens.tickets.create.error_description]: 'Could not create the ticket',
  [tokens.tickets.chat.title]: 'Chat with support',
  [tokens.tickets.chat.reference]: 'Reference:',
  [tokens.tickets.chat.empty_title]: 'No messages yet',
  [tokens.tickets.chat.empty_subtitle]: 'Be the first to start the conversation!',
  [tokens.tickets.chat.input_placeholder]: 'Type your message',
  [tokens.tickets.chat.user_label]: 'Me',
  [tokens.tickets.chat.support_label]: 'Support',
  [tokens.tickets.chat.conversation_title]: 'Chat with support',
  [tokens.tickets.chat.conversation_subtitle]: 'Our team of experts will handle your case and provide a solution as soon as possible.',
  [tokens.tickets.chat.no_messages_title]: 'No messages yet',
  [tokens.tickets.chat.no_messages_subtitle]: 'Start the conversation by sending a message',
  [tokens.tickets.chat.input_placeholder_detail]: 'Type your message...',
  [tokens.tickets.close.dialog_title]: 'Close Ticket',
  [tokens.tickets.close.dialog_description]: 'Are you sure you want to close this ticket? This action cannot be undone.',
  [tokens.tickets.close.dialog_confirm]: 'Close',
  [tokens.tickets.status.open]: 'Open',
  [tokens.tickets.status.in_progress]: 'In Progress',
  [tokens.tickets.status.blocked]: 'Blocked',
  [tokens.tickets.status.resolved]: 'Resolved',
  [tokens.tickets.type.technical_problems]: 'Technical',
  [tokens.tickets.type.integration_problems]: 'Integration',
  [tokens.tickets.type.security_issues]: 'Security',
  [tokens.tickets.type.suggestions]: 'Suggestions',
  [tokens.tickets.type.others]: 'Others',
  [tokens.assistant.tools.title]: 'Tools',
  [tokens.assistant.tools.extractions.title]: 'Extractions',
  [tokens.assistant.tools.extractions.description.message]: 'Configure fields to collect information during conversations',
  [tokens.assistant.tools.extractions.empty.message]: 'No extractions configured',
  [tokens.assistant.tools.extractions.empty.description]: 'Create a new extraction to start collecting information from users',
  [tokens.assistant.tools.extractions.add]: 'Add Extraction',
  [tokens.assistant.tools.extractions.create]: 'Create Extraction',
  [tokens.assistant.tools.extractions.edit]: 'Edit Extraction',
  [tokens.assistant.tools.extractions.delete.message]: 'Delete Extraction',
  [tokens.assistant.tools.extractions.delete.confirm]: 'Are you sure you want to delete this extraction?',
  [tokens.assistant.tools.extractions.delete.description]: 'This action cannot be undone. Already collected data will be kept.',
  [tokens.assistant.tools.extractions.name.message]: 'Extraction Name',
  [tokens.assistant.tools.extractions.name.placeholder]: 'Ex: Customer Data',
  [tokens.assistant.tools.extractions.description.label]: 'Description',
  [tokens.assistant.tools.extractions.description.placeholder]: 'Describe what this extraction collects',
  [tokens.assistant.tools.extractions.fields]: 'Fields',
  [tokens.assistant.tools.extractions.field.name.message]: 'Field Name',
  [tokens.assistant.tools.extractions.field.name.placeholder]: 'Ex: full_name',
  [tokens.assistant.tools.extractions.field.description.message]: 'Field Description',
  [tokens.assistant.tools.extractions.field.description.placeholder]: 'Ex: User\'s full name',
  [tokens.assistant.tools.extractions.field.examples.message]: 'Examples',
  [tokens.assistant.tools.extractions.field.examples.placeholder]: 'Add examples of expected values',
  [tokens.assistant.tools.extractions.field.required]: 'Required Field',
  [tokens.assistant.tools.extractions.field.add]: 'Add Field',
  [tokens.assistant.tools.extractions.field.remove]: 'Remove Field',
  [tokens.assistant.tools.extractions.save]: 'Save Extraction',
  [tokens.assistant.tools.extractions.cancel]: 'Cancel',
  [tokens.assistant.tools.extractions.success.created]: 'Extraction created successfully',
  [tokens.assistant.tools.extractions.success.updated]: 'Extraction updated successfully',
  [tokens.assistant.tools.extractions.success.deleted]: 'Extraction deleted successfully',
  [tokens.assistant.tools.extractions.error.create]: 'Error creating extraction',
  [tokens.assistant.tools.extractions.error.update]: 'Error updating extraction',
  [tokens.assistant.tools.extractions.error.delete]: 'Error deleting extraction',
  [tokens.assistant.tools.extractions.validation.name.required]: 'Extraction name is required',
  [tokens.assistant.tools.extractions.validation.description.required]: 'Extraction description is required',
  [tokens.assistant.tools.extractions.validation.fields.required]: 'At least one field is required',
  [tokens.assistant.tools.extractions.validation.field.name.required]: 'Field name is required',
  [tokens.assistant.tools.extractions.validation.field.description.required]: 'Field description is required',
  [tokens.assistant.collectedData.title]: 'Collected Data',
  [tokens.assistant.collectedData.empty.message]: 'No data collected yet',
  [tokens.assistant.collectedData.empty.description]: 'Data collected through extractions will appear here',
  [tokens.assistant.collectedData.export]: 'Export to CSV',
  [tokens.assistant.collectedData.refresh]: 'Refresh',
  [tokens.assistant.collectedData.filter.extraction]: 'Filter by Extraction',
  [tokens.assistant.collectedData.filter.date]: 'Filter by Date',
  [tokens.assistant.collectedData.filter.chat]: 'Filter by Chat',
  [tokens.assistant.collectedData.table.date]: 'Date/Time',
  [tokens.assistant.collectedData.table.chat]: 'Chat ID',
  [tokens.assistant.collectedData.table.extraction]: 'Extraction',
  [tokens.assistant.collectedData.table.field]: 'Field',
  [tokens.assistant.collectedData.table.value]: 'Value',
  [tokens.assistant.collectedData.loading]: 'Loading data...',
  [tokens.assistant.collectedData.error]: 'Error loading collected data',
  [tokens.assistant.collectedData.perChat]: 'By Chat',
  [tokens.assistant.collectedData.allData]: 'All Data',
  [tokens.assistant.version.tools.warning]: 'Configured tools will only apply to this version',
  [tokens.assistant.version.deployed]: 'Deployed',
  [tokens.assistant.dashboard.title]: 'Overview',
  [tokens.assistant.dashboard.collectedData]: 'Collected Data',
  [tokens.assistant.dashboard.conversations]: 'Conversations',
  [tokens.assistant.dashboard.conversationsDesc]: 'Conversation statistics and metrics',
  [tokens.assistant.dashboard.versions]: 'Versions',
  [tokens.assistant.dashboard.versionsDesc]: 'Assistant version management',
  [tokens.assistant.dashboard.settings]: 'Settings',
  [tokens.assistant.dashboard.noDeployedVersion]: 'No deployed version',
  [tokens.assistant.dashboard.recentVersions]: 'Recent Versions',
  [tokens.assistant.dashboard.activeConversations]: 'active conversations',
  [tokens.assistant.dashboard.avgMessages]: 'Average messages',
  [tokens.assistant.dashboard.satisfaction]: 'Satisfaction',
  [tokens.assistant.dashboard.uniqueUsers]: 'unique users',
  [tokens.assistant.mention.createExtraction]: 'Create new extraction',
  [tokens.assistant.mention.addField]: 'Add field',
  [tokens.assistant.mention.fieldExample]: 'Field example',
  [tokens.assistant.extraction.tooltip]: 'Tab to exit mention • Click on yellow mentions to create extraction',
  [tokens.assistant.extraction.update_temporary]: 'Extraction temporarily updated',
  [tokens.assistant.extraction.update_temporary_description]: 'Changes will be saved when creating a new version',
  [tokens.assistant.extraction.create_temporary]: 'Extraction temporarily created',
  [tokens.assistant.extraction.create_temporary_description]: 'Will be permanently saved when creating new version',
  [tokens.assistant.extraction.unsaved_badge]: 'Unsaved extractions',
  [tokens.assistant.extraction.inserted]: 'Extraction inserted',
  [tokens.assistant.extraction.inserted_description]: '@{{mentionName}} was inserted in the text',
  [tokens.assistant.extraction.field_placeholder]: 'field_name',
  [tokens.assistant.extraction.field_description]: 'Field to collect {{fieldName}}',
  [tokens.assistant.extraction.steps.name]: 'Name',
  [tokens.assistant.extraction.steps.examples]: 'Examples',
  [tokens.assistant.extraction.steps.description]: 'Description',
  [tokens.assistant.extraction.update_button]: 'Update',
  [tokens.assistant.dashboard.metrics.conversations]: 'Conversations',
  [tokens.assistant.dashboard.metrics.conversations_tooltip]: 'Total conversations',
  [tokens.assistant.dashboard.metrics.users]: 'Users',
  [tokens.assistant.dashboard.metrics.users_tooltip]: 'Unique users',
  [tokens.assistant.dashboard.metrics.extractions]: 'Extractions',
  [tokens.assistant.dashboard.metrics.extractions_tooltip]: 'Total extracted information',
  [tokens.assistant.dashboard.metrics.satisfaction]: 'Satisfaction',
  [tokens.assistant.dashboard.metrics.satisfaction_tooltip]: 'Satisfaction rate',
  [tokens.assistant.dashboard.metrics.response_rate]: 'Response Rate',
  [tokens.assistant.dashboard.metrics.response_rate_tooltip]: 'Conversations answered by assistant',
  [tokens.assistant.dashboard.health.title]: 'How is my Assistant?',
  [tokens.assistant.dashboard.health.subtitle]: 'Real-time health and performance indicators',
  [tokens.assistant.dashboard.health.excellent]: 'Excellent',
  [tokens.assistant.dashboard.health.attention]: 'Attention Required',
  [tokens.assistant.dashboard.health.action]: 'Requires Immediate Action',
  [tokens.assistant.dashboard.health.response_rate_desc]: 'Percentage of queries that received response',
  [tokens.assistant.dashboard.health.success_rate]: 'Success Rate',
  [tokens.assistant.dashboard.health.success_rate_desc]: 'Percentage of responses considered accurate',
  [tokens.assistant.dashboard.health.satisfaction_desc]: 'Average user rating on responses',
  [tokens.assistant.dashboard.health.availability]: 'Availability',
  [tokens.assistant.dashboard.health.availability_desc]: 'Time the assistant was available for use',
  [tokens.assistant.dashboard.health.status]: 'Overall Status',
  [tokens.assistant.dashboard.health.score]: 'Health score',
  [tokens.assistant.dashboard.improvements.high_impact]: 'High Impact',
  [tokens.assistant.dashboard.improvements.medium_impact]: 'Medium Impact',
  [tokens.assistant.dashboard.improvements.low_impact]: 'Low Impact',
  [tokens.assistant.dashboard.improvements.easy]: 'Easy',
  [tokens.assistant.dashboard.improvements.medium]: 'Medium',
  [tokens.assistant.dashboard.improvements.hard]: 'Hard',
  [tokens.assistant.dashboard.improvements.progress]: 'Current progress',
  [tokens.assistant.dashboard.improvements.difficulty]: 'Difficulty',
  [tokens.assistant.dashboard.improvements.improve_response_rate]: 'Improve Response Rate',
  [tokens.assistant.dashboard.improvements.improve_response_rate_desc]: 'Optimize system to reduce failures and increase response reliability.',
  [tokens.assistant.dashboard.improvements.analyze_failures]: 'Analyze Failures',
  [tokens.assistant.dashboard.improvements.increase_accuracy]: 'Increase Response Accuracy',
  [tokens.assistant.dashboard.improvements.increase_accuracy_desc]: 'Better train the assistant with more specific examples from your domain.',
  [tokens.assistant.dashboard.improvements.review_training]: 'Review Training',
  [tokens.assistant.dashboard.improvements.improve_satisfaction]: 'Improve User Satisfaction',
  [tokens.assistant.dashboard.improvements.improve_satisfaction_desc]: 'Collect more feedback and adjust responses based on user preferences.',
  [tokens.assistant.dashboard.improvements.collect_feedback]: 'Collect Feedback',
  [tokens.assistant.dashboard.improvements.reduce_response_time]: 'Reduce Response Time',
  [tokens.assistant.dashboard.improvements.reduce_response_time_desc]: 'Optimize processing to respond faster to user queries.',
  [tokens.assistant.dashboard.improvements.optimize_performance]: 'Optimize Performance',
  [tokens.assistant.dashboard.improvements.increase_data_collection]: 'Increase Data Collection',
  [tokens.assistant.dashboard.improvements.increase_data_collection_desc]: 'Configure more extractions to collect valuable user information.',
  [tokens.assistant.dashboard.improvements.create_extractions]: 'Create Extractions',
  [tokens.assistant.dashboard.improvements.increase_engagement]: 'Increase Engagement',
  [tokens.assistant.dashboard.improvements.increase_engagement_desc]: 'Better promote the assistant or improve initial user experience.',
  [tokens.assistant.dashboard.improvements.marketing_strategies]: 'Marketing Strategies',
  [tokens.assistant.dashboard.collected.filtered]: 'Filtered',
  [tokens.assistant.dashboard.collected.all]: 'All',
  [tokens.assistant.dashboard.collected.title]: 'Collected Information',
  [tokens.assistant.dashboard.collected.subtitle]: 'Data extracted by assistants',
  [tokens.assistant.dashboard.collected.total]: 'Total',
  [tokens.assistant.dashboard.collected.today]: 'Today',
  [tokens.assistant.dashboard.collected.extractions]: 'Extractions',
  [tokens.assistant.dashboard.collected.fields]: 'Fields',
  [tokens.assistant.dashboard.collected.total_collected]: 'Total collected',
  [tokens.assistant.dashboard.collected.unique_fields]: 'Unique fields',
  [tokens.assistant.dashboard.collected.all_extractions]: 'All extractions',
  [tokens.assistant.dashboard.peak.title]: 'Peak Hours',
  [tokens.assistant.dashboard.peak.subtitle]: 'Activity analysis by day and hour',
  [tokens.assistant.dashboard.peak.peak_hour]: 'Peak Hour',
  [tokens.assistant.dashboard.peak.conversations_at_time]: '{{count}} conversations at this time',
  [tokens.assistant.dashboard.peak.peak_time_alert]: 'Peak time!',
  [tokens.assistant.dashboard.peak.busiest_day]: 'Busiest Day',
  [tokens.assistant.dashboard.peak.total_analyzed]: 'Total Analyzed',
  [tokens.assistant.dashboard.peak.conversations_last_days]: '{{count}} conversations in the last {{days}} days',
  [tokens.assistant.dashboard.peak.heatmap_title]: 'Heatmap - Activity by Hour',
  [tokens.assistant.dashboard.peak.less]: 'Less',
  [tokens.assistant.dashboard.peak.more]: 'More',
  [tokens.assistant.dashboard.peak.busiest_hours]: 'Busiest Hours',
  [tokens.assistant.dashboard.peak.conversations]: 'conversations',
  [tokens.assistant.dashboard.peak.sunday]: 'Sun',
  [tokens.assistant.dashboard.peak.monday]: 'Mon',
  [tokens.assistant.dashboard.peak.tuesday]: 'Tue',
  [tokens.assistant.dashboard.peak.wednesday]: 'Wed',
  [tokens.assistant.dashboard.peak.thursday]: 'Thu',
  [tokens.assistant.dashboard.peak.friday]: 'Fri',
  [tokens.assistant.dashboard.peak.saturday]: 'Sat',
  [tokens.assistant.dashboard.export.conversations_report]: 'Conversations Report',
  [tokens.assistant.dashboard.export.conversations_report_desc]: 'Complete data from all conversations and interactions',
  [tokens.assistant.dashboard.export.collected_data]: 'Collected Data',
  [tokens.assistant.dashboard.export.collected_data_desc]: 'Information extracted by assistants',
  [tokens.assistant.dashboard.export.export_now]: 'Export Now',
  [tokens.assistant.dashboard.export.export_data]: 'Export Data',
  [tokens.assistant.dashboard.export.export_reports]: 'Export Reports',
  [tokens.assistant.dashboard.export.select_data]: 'Select the data you want to export',
  [tokens.assistant.dashboard.export.cancel]: 'Cancel',
  [tokens.assistant.dashboard.export.export]: 'Export',
  [tokens.assistant.dashboard.export.automatic_reports]: 'Automatic Reports',
  [tokens.assistant.dashboard.export.configure_automatic]: 'Configure automatic email delivery',
  [tokens.assistant.dashboard.export.configure_schedule]: 'Configure Schedule',
  [tokens.assistant.dashboard.export.schedule_reports]: 'Schedule Reports',
  [tokens.assistant.dashboard.export.schedule_description]: 'Configure automatic report delivery by email',
  [tokens.assistant.dashboard.export.email_label]: 'Email for delivery',
  [tokens.assistant.dashboard.export.email_placeholder]: 'your@email.com',
  [tokens.assistant.dashboard.export.frequency]: 'Frequency',
  [tokens.assistant.dashboard.export.daily]: 'Daily',
  [tokens.assistant.dashboard.export.weekly]: 'Weekly',
  [tokens.assistant.dashboard.export.monthly]: 'Monthly',
  [tokens.assistant.dashboard.export.report_types]: 'Report types',
  [tokens.assistant.dashboard.export.active_schedules]: 'Active Schedules',
  [tokens.assistant.dashboard.export.active]: 'Active',
  [tokens.assistant.dashboard.export.next_delivery]: 'Next delivery:',
  [tokens.assistant.dashboard.time.minutes_suffix]: 'min',
  [tokens.assistant.extraction.press_enter_continue]: 'Press Enter to continue',
  [tokens.assistant.extraction.default_field_name]: 'field',
  [tokens.assistant.dashboard.time_filter.all_data]: 'All data',
  [tokens.assistant.dashboard.time_filter.last_hour]: 'Last hour',
  [tokens.assistant.dashboard.time_filter.last_2h]: 'Last 2h',
  [tokens.assistant.dashboard.time_filter.last_6h]: 'Last 6h',
  [tokens.assistant.dashboard.time_filter.last_12h]: 'Last 12h',
  [tokens.assistant.dashboard.time_filter.last_24h]: 'Last 24h',
  [tokens.assistant.dashboard.time_filter.today]: 'Today',
  [tokens.assistant.dashboard.production]: 'Production',
  [tokens.assistant.dashboard.preview]: 'Preview',
  [tokens.assistant.dashboard.showData]: 'Show data',
  [tokens.assistant.dashboard.hideData]: 'Hide data',
  [tokens.assistant.dashboard.previewDataNotPersistent]: 'Preview data is not persistent',
  [tokens.assistant.dashboard.configure]: 'Configure',
  [tokens.assistant.dashboard.description]: 'Track metrics and performance',
  [tokens.assistant.dashboard.whatsappAnalytics]: 'WhatsApp Analytics',
  [tokens.assistant.dashboard.whatsappActivityEngagement]: 'WhatsApp activity and engagement',
  [tokens.assistant.dashboard.activityLevel]: 'Activity level',
  [tokens.assistant.dashboard.responseTime]: 'Response time',
  [tokens.assistant.dashboard.totalMessages]: 'Total messages',
  [tokens.assistant.dashboard.peakHours]: 'Peak hours',
  [tokens.assistant.extraction.add_description_optional]: 'Add description (optional)',
  [tokens.assistant.dashboard.conversation.default_user]: 'User',
  [tokens.assistant.dashboard.editAssistant]: 'Edit Assistant',
  [tokens.assistant.dashboard.improvements.title]: 'Improvement Opportunities',
  [tokens.assistant.dashboard.improvements.subtitle]: 'Identify areas to optimize your assistant\'s performance',
  [tokens.assistant.dashboard.improvements.all_perfect]: 'Everything is perfect!',
  [tokens.assistant.dashboard.improvements.optimal_operation]: 'Your assistant is operating optimally with no immediate improvements needed.',
  [tokens.assistant.dashboard.improvements.excellent_performance]: 'Excellent Performance',
  [tokens.assistant.dashboard.improvements.opportunities_identified]: '{count} opportunities identified',
  [tokens.assistant.dashboard.improvements.prioritize_actions]: 'Prioritize high-impact actions for better results',
  [tokens.assistant.dashboard.improvements.improvements]: 'improvements',
  [tokens.assistant.dashboard.export.title]: 'Export and Schedule Reports',
  [tokens.assistant.dashboard.export.subtitle]: 'Set up automatic data exports and reports',
  [tokens.assistant.dashboard.export.download_reports_desc]: 'Download detailed reports of your assistant',
  [tokens.assistant.dashboard.export.no_schedules_yet]: 'No schedules configured yet',
  [tokens.assistant.dashboard.export.paused]: 'Paused',
  [tokens.assistant.dashboard.export.performance_metrics]: 'Performance Metrics',
  [tokens.assistant.dashboard.export.performance_metrics_desc]: 'Detailed performance and efficiency analysis',
  [tokens.assistant.dashboard.export.executive_report]: 'Executive Report',
  [tokens.assistant.dashboard.export.executive_report_desc]: 'Executive summary with key indicators',
  [tokens.assistant.dashboard.export.daily_summary]: 'Daily Summary',
  [tokens.assistant.dashboard.export.daily_summary_desc]: 'Summary of daily activities',
  [tokens.assistant.dashboard.excellent]: 'Excellent',
  [tokens.assistant.dashboard.performance]: 'Performance',
  [tokens.assistant.dashboard.performanceMetrics]: 'Performance Metrics',
  [tokens.assistant.dashboard.collected.csv_filename_prefix]: 'collected-data-',
  [tokens.assistant.dashboard.collected.extraction_details]: 'Extraction details',
  [tokens.assistant.dashboard.collected.last_collection]: 'Last collection',
  [tokens.assistant.dashboard.recentConversations]: 'Recent Conversations',
  [tokens.assistant.dashboard.export.weekly_report]: 'Weekly Report',
  [tokens.assistant.dashboard.export.weekly_report_desc]: 'Weekly summary with analysis and trends',
  [tokens.assistant.dashboard.export.monthly_insights]: 'Monthly Insights',
  [tokens.assistant.dashboard.export.monthly_insights_desc]: 'Monthly deep analysis with strategic insights',
  [tokens.assistant.dashboard.good]: 'Good',
  [tokens.assistant.dashboard.regular]: 'Regular',
  [tokens.assistant.dashboard.activeChats]: 'Active Chats',
  [tokens.assistant.dashboard.uniqueUsersCount]: 'Total Unique Users',
  [tokens.assistant.dashboard.peak.insufficient_data]: 'Insufficient data for time analysis',
  [tokens.assistant.createAssistantSuccess.title]: 'Assistant created',
  [tokens.assistant.createAssistantSuccess.description]: 'The assistant was created successfully.',
  [tokens.assistant.createAssistantError.title]: 'Error creating assistant',
  [tokens.assistant.createAssistantError.description]: 'An error occurred while creating the assistant.',
  [tokens.assistant.deleteAssistantSuccess.title]: 'Assistant deleted',
  [tokens.assistant.deleteAssistantSuccess.description]: 'The assistant was deleted successfully.',
  [tokens.assistant.deleteAssistantError.title]: 'Error deleting assistant',
  [tokens.assistant.deleteAssistantError.description]: 'An error occurred while deleting the assistant.',
  [tokens.assistant.createVersionSuccess.title]: 'Version created',
  [tokens.assistant.createVersionSuccess.description]: 'The version was created successfully.',
  [tokens.assistant.createVersionError.title]: 'Error creating version',
  [tokens.assistant.createVersionError.description]: 'An error occurred while creating the version.',
  [tokens.assistant.deployVersionSuccess.title]: 'Version deployed',
  [tokens.assistant.deployVersionSuccess.description]: 'The version was deployed successfully.',
  [tokens.assistant.deployVersionError.title]: 'Error deploying version',
  [tokens.assistant.deployVersionError.description]: 'An error occurred while deploying the version.',
  [tokens.assistant.deleteVersionSuccess.title]: 'Version deleted',
  [tokens.assistant.deleteVersionSuccess.description]: 'The version was deleted successfully.',
  [tokens.assistant.deleteVersionError.title]: 'Error deleting version',
  [tokens.assistant.deleteVersionError.description]: 'An error occurred while deleting the version.',
  [tokens.file_table_input.dialog.title]: 'Upload Files and Links',
  [tokens.file_table_input.files.label]: 'Files',
  [tokens.file_table_input.drag_drop.main_text]: 'Drag files here or click to select',
  [tokens.file_table_input.drag_drop.supported_formats]: 'Support for PDF, DOC, DOCX, PPT, PPTX, XLS, XLSX, MP4, MP3, WEBM',
  [tokens.file_table_input.drag_drop.max_size]: 'Maximum size: 400 MB per file',
  [tokens.file_table_input.selected_files.label]: 'Selected Files',
  [tokens.file_table_input.youtube.label]: 'YouTube Links',
  [tokens.file_table_input.youtube.warning]: 'YouTube videos may take a bit longer to appear after being added.',
  [tokens.file_table_input.youtube.url_placeholder]: 'Paste YouTube link here...',
  [tokens.file_table_input.youtube.name_placeholder]: 'Video name',
  [tokens.file_table_input.youtube.add_button]: 'Add Video',
  [tokens.file_table_input.youtube.added_links.label]: 'Added Links',
  [tokens.file_table_input.buttons.cancel]: 'Cancel',
  [tokens.file_table_input.buttons.upload]: 'Upload',
  [tokens.file_table_input.buttons.uploading]: 'Uploading...',
  [tokens.file_table_input.toast.cannot_upload.title]: 'Cannot upload file',
  [tokens.file_table_input.toast.cannot_upload.description]: 'The file "{fileName}" exceeds the current organization\'s MB limit and could not be loaded.',
  [tokens.file_table_input.toast.file_too_large.title]: 'File too large',
  [tokens.file_table_input.toast.file_too_large.description]: 'The file "{fileName}" exceeds the {limit} GB limit and could not be loaded.',
  [tokens.file_table_input.toast.invalid_url.title]: 'Invalid URL',
  [tokens.file_table_input.toast.invalid_url.description]: 'insira uma URL válida do YouTube.',
  [tokens.file_table_input.toast.invalid_video_id.title]: 'Invalid URL',
  [tokens.file_table_input.toast.invalid_video_id.description]: 'Could not extract video ID from the provided URL.',
  [tokens.file_table_input.toast.duplicate_video.title]: 'Duplicate video',
  [tokens.file_table_input.toast.duplicate_video.description]: 'This video has already been added to the list.',
  [tokens.file_table_input.toast.no_content.title]: 'No content selected',
  [tokens.file_table_input.toast.no_content.description]: 'Select at least one file or add a YouTube link.',
  [tokens.file_table_input.toast.no_folder.title]: 'No folder selected',
  [tokens.file_table_input.toast.no_folder.description]: 'Select a folder before uploading.',
  [tokens.file_table_input.toast.upload_failed.title]: 'Upload failed',
  [tokens.file_table_input.toast.upload_failed.description]: 'Failed to upload "{fileName}": {error}',
  [tokens.file_table_input.toast.upload_success.title]: 'Upload completed successfully',
  [tokens.file_table_input.toast.upload_success.description]: 'Files and links uploaded successfully.',
  [tokens.sidebar.translation.title]: 'Translator',
  [tokens.sidebar.translation.fileManage]: 'Templates',
  [tokens.sidebar.translation.glossary]: 'Glossaries',
  [tokens.sidebar.translation.translation]: 'Translations',
  [tokens.translation.fileManage.title]: 'Templates',
  [tokens.translation.fileManage.description]: 'Translation template management',
  [tokens.translation.fileManage.searchPlaceholder]: 'Search templates…',
  [tokens.ui.common.openMenu]: 'Open menu',
  [tokens.translation.fileManage.uploadInput.sendFileForTranslation]: 'Send file for translation',
  [tokens.translation.fileManage.uploadInput.sendTemplate]: 'Send template',
  [tokens.translation.fileManage.uploadInput.templateFormattingInstructionOne]:
    'Use the [/TEXTO] marker to indicate where the translation will be inserted.',
  [tokens.translation.fileManage.uploadInput.templateFormattingInstructionTwo]:
    'You may add optional formatting attributes, they apply only to the translated text and do not change the rest of the template formatting.',
  [tokens.translation.fileManage.uploadInput.templateFormattingExampleLabel]: 'Formatting example',
  [tokens.translation.fileManage.uploadInput.templateFormattingExampleValue]:
    '[/TEXTO, font=Arial, size=12]',
  [tokens.translation.fileManage.uploadInput.templateFormattingCopyButton]: 'Copy',
  [tokens.translation.fileManage.uploadInput.templateFormattingCopiedShort]: 'Copied',
  [tokens.translation.fileManage.uploadInput.templateFormattingCopiedTitle]: 'Example copied',
  [tokens.translation.fileManage.uploadInput.templateFormattingCopiedDescription]:
    'The formatting marker was copied to your clipboard.',
  [tokens.translation.fileManage.uploadInput.templateFormattingCopyFailedTitle]: 'Copy failed',
  [tokens.translation.fileManage.uploadInput.templateFormattingCopyFailedDescription]:
    'Could not copy the example. Please try again.',
  [tokens.translation.fileManage.deleteDialog.deleteFileTitle]: 'Delete file',
  [tokens.translation.fileManage.deleteDialog.deleteFilesTitle]: 'Delete files',
  [tokens.translation.fileManage.deleteDialog.deleteFileDescription]: 'You are about to delete a file. This action cannot be undone.',
  [tokens.translation.fileManage.deleteDialog.deleteFilesDescription]: 'You are about to delete {{count}} files. This action cannot be undone.',
  [tokens.translation.fileManage.table.selectAllFiles]: 'Select all files',
  [tokens.translation.fileManage.table.selectRow]: 'Select row',
  [tokens.translation.fileManage.table.noFilesFound]: 'No files found',
  [tokens.translation.fileManage.table.loadingFiles]: 'Loading files...',
  [tokens.translation.fileManage.table.previousPage]: 'Previous page',
  [tokens.translation.fileManage.table.nextPage]: 'Next page',
  [tokens.translation.fileManage.tabs.filesForTranslation]: 'Files for translation',
  [tokens.translation.fileManage.tabs.templates]: 'Templates',
  [tokens.translation.glossary.title]: 'Glossaries',
  [tokens.translation.glossary.description]: 'Glossaries of terms that may be used during translation',
  [tokens.translation.glossary.deleteDialog.deleteGlossariesTitle]: 'Delete glossaries',
  [tokens.translation.glossary.deleteDialog.deleteGlossariesDescription]: 'You are about to delete {{count}} glossaries. This action cannot be undone.',
  [tokens.translation.glossary.table.selectAllGlossaries]: 'Select all glossaries',
  [tokens.translation.glossary.table.selectRow]: 'Select row',
  [tokens.translation.glossary.table.name]: 'Glossary Name',
  [tokens.translation.glossary.table.noGlossariesFound]: 'No glossaries found',
  [tokens.translation.glossary.table.loadingGlossaries]: 'Loading glossaries...',
  [tokens.translation.glossary.toolbar.createButton]: 'New glossary',
  [tokens.ui.toasts.glossary.create_success]: 'Glossary created successfully.',
  [tokens.ui.toasts.glossary.update_success]: 'Glossary updated successfully.',
  [tokens.ui.toasts.glossary.delete_success]: 'Glossary deleted successfully.',
  [tokens.ui.toasts.glossary.duplicate_success]: 'Glossary duplicated successfully.',
  [tokens.ui.toasts.folder.update_success]: 'The folder has been updated successfully',
  [tokens.ui.toasts.translation.delete_success]: 'Translations deleted successfully',
  [tokens.file_table_input.drag_drop.max_size_translation]: 'Maximum size: 50 MB per file',
  [tokens.file_table_input.file_too_large_inline]: 'File exceeds 50MB limit',
  [tokens.translation.translation.title]: 'Translations',
  [tokens.translation.translation.description]: 'Translation management',
  [tokens.translation.translation.createDialog.reviewBeforeFinish]: 'Review before finishing',
  [tokens.translation.translation.createDialog.autoSplit]: 'Automatic division',
  [tokens.translation.translation.createDialog.autoSplitTooltip]: 'Enable this option to automatically split the input document into multiple documents.',
  [tokens.translation.translation.createDialog.extractTables]: 'Table extraction',
  [tokens.translation.translation.createDialog.start]: 'Start',
  [tokens.translation.translation.pdfViewer.errorLoading]: 'Error loading PDF',
  [tokens.translation.translation.pdfViewer.zoomIn]: 'Zoom in',
  [tokens.translation.translation.pdfViewer.zoomOut]: 'Zoom out',
  [tokens.translation.translation.reviewDialog.couldNotLoadData]: 'Could not load review data.',
  [tokens.translation.translation.reviewDialog.singleEdit]: '1 edit',
  [tokens.translation.translation.reviewDialog.multipleEdits]: '{{count}} edits',
  [tokens.translation.translation.reviewDialog.title]: 'Translation Review',
  [tokens.translation.translation.reviewDialog.confirmTranslation]: 'Confirm Translation',
  [tokens.translation.translation.reviewDialog.sendFeedback]: 'Send feedback',
  [tokens.translation.translation.reviewDialog.waitApplyingChanges]: 'Applying the corrections, they will be used automatically in future translations.',
  [tokens.translation.translation.reviewDialog.preparingSingleFile]: 'Preparing your file.',
  [tokens.translation.translation.reviewDialog.preparingMultipleFiles]: 'Preparing your files.',
  [tokens.translation.translation.reviewDialog.documentOfTotal]: 'Document {{current}} of {{total}}',
  [tokens.translation.translation.reviewDialog.reprocess]: 'Translate again',
  [tokens.translation.translation.reviewPanel.originalLabel]: 'Original ({{language}})',
  [tokens.translation.translation.reviewPanel.translatedLabel]: 'Translated ({{language}})',
  [tokens.translation.translation.reviewPanel.tooltipRotatePdf]: 'Rotate',
  [tokens.translation.translation.reviewPanel.tooltipZoomIn]: 'Zoom in',
  [tokens.translation.translation.reviewPanel.tooltipZoomOut]: 'Zoom out',
  [tokens.translation.translation.reviewPanel.tooltipZoomReset]: 'Reset zoom',
  [tokens.translation.translation.feedbackDialog.title]: 'Send feedback',
  [tokens.translation.translation.feedbackDialog.descriptionPlaceholder]: 'Describe the problem or suggestion',
  [tokens.translation.translation.feedbackDialog.selectImage]: 'Select image',
  [tokens.translation.translation.feedbackDialog.filesHint]: 'Paste or select images ({{count}}/{{total}})',
  [tokens.translation.translation.feedbackDialog.cancel]: 'Cancel',
  [tokens.translation.translation.feedbackDialog.submit]: 'Send feedback',
  [tokens.translation.translation.feedbackDialog.toast.successTitle]: 'Feedback sent',
  [tokens.translation.translation.feedbackDialog.toast.errorTitle]: 'Failed to send feedback',
  [tokens.translation.translation.feedbackDialog.toast.errorDescription]: 'Please try again in a few moments.',
  [tokens.translation.translation.feedbackDialog.validation.descriptionMin]: 'Please provide at least 3 characters.',
  [tokens.translation.translation.feedbackDialog.validation.descriptionMax]: 'Description must be at most 2000 characters.',
  [tokens.translation.translation.feedbackDialog.validation.maxFiles]: 'You can attach up to {{max}} images per feedback.',
  [tokens.translation.translation.feedbackDialog.validation.onlyImages]: 'Only images are accepted.',
  [tokens.translation.translation.feedbackDialog.validation.maxFileSize]: 'Only images up to 20MB are accepted.',
  [tokens.translation.translation.selectGlossary.noGlossariesFound]: 'No glossaries found',
  [tokens.translation.translation.selectGlossary.placeholder]: 'Select glossary',
  [tokens.translation.translation.selectGlossary.searchPlaceholder]: 'Search glossary',
  [tokens.translation.translation.selectTemplateFile.noFilesFound]: 'No files found',
  [tokens.translation.translation.selectTemplateFile.placeholder]: 'Select template file',
  [tokens.translation.translation.selectTranslationFile.noFilesFound]: 'No files found',
  [tokens.translation.translation.selectTranslationFile.placeholder]: 'Select file to translate',
  [tokens.translation.translation.historyTable.status.complete]: 'Complete',
  [tokens.translation.translation.historyTable.status.pending]: 'Pending',
  [tokens.translation.translation.historyTable.status.running]: 'Processing',
  [tokens.translation.translation.historyTable.status.review]: 'Review',
  [tokens.translation.translation.historyTable.status.error]: 'Failed',
  [tokens.translation.translation.historyTable.status.quotaExceeded]: 'Quota exceeded',
  [tokens.translation.translation.historyTable.createdBy]: 'Created by',
  [tokens.translation.translation.historyTable.openReview]: 'Review',
  [tokens.translation.translation.historyTable.reprocess]: 'Translate again',
  [tokens.translation.translation.reprocess.toast.startedTitle]: 'Translation restarted',
  [tokens.translation.translation.reprocess.toast.startedDescription]: 'This translation is being processed again.',
  [tokens.translation.translation.reprocess.toast.alreadyRunningTitle]: 'Already running',
  [tokens.translation.translation.reprocess.toast.alreadyRunningDescription]: 'A workflow is already in progress for this translation.',
  [tokens.translation.translation.reprocess.toast.errorTitle]: 'Could not re-run',
  [tokens.translation.translation.reprocess.toast.errorDescription]: 'Something went wrong. Please try again.',
  [tokens.translation.translation.historyTable.noTranslationsFound]: 'No translations found',
  [tokens.translation.translation.historyTable.loadingTranslations]: 'Loading translations...',
  [tokens.translation.translation.historyToolbar.searchPlaceholder]: 'Search translation',
  [tokens.translation.translation.reviewDialog.applyChanges]: 'Apply Changes',
  [tokens.translation.translation.reviewDialog.applyingChanges]: 'Applying your changes, please wait...',
  [tokens.translation.translation.completeDialog.title]: 'Download Files',
  [tokens.translation.translation.completeDialog.couldNotLoadData]: 'Could not load file data.',
  [tokens.translation.translation.completeDialog.originalFile]: 'Original File',
  [tokens.translation.translation.completeDialog.translatedFiles]: 'Translated Files',
  [tokens.translation.translation.completeDialog.translatedFile]: 'Translated File',
  [tokens.translation.translation.completeDialog.downloadAll]: 'Download All',
  [tokens.translation.translation.completeDialog.downloadError.title]: 'Download error',
  [tokens.translation.translation.completeDialog.downloadError.description]: 'Could not create ZIP file. Please try again later.',
  [tokens.translation.translation.completeDialog.reprocess]: 'Translate again',
  [tokens.assistant.conversations.title]: 'Conversations',
  [tokens.assistant.conversations.description]: 'View all conversations from assistant {{name}}',
  [tokens.assistant.conversations.viewAll]: 'View Conversations',
  [tokens.assistant.conversations.backToDashboard]: 'Back to Dashboard',
  [tokens.assistant.conversations.noResults]: 'No conversations found',
  [tokens.assistant.conversations.viewDetails]: 'View details',
  [tokens.assistant.conversations.viewConversation]: 'View conversation',
  [tokens.assistant.conversations.export]: 'Export CSV',
  [tokens.assistant.conversations.hiddenContent]: 'Hidden content',
  [tokens.assistant.conversations.hideSensitiveData]: 'Hide sensitive data',
  [tokens.assistant.conversations.showSensitiveData]: 'Show sensitive data',
  [tokens.assistant.conversations.hideData]: 'Hide',
  [tokens.assistant.conversations.showData]: 'Show',
  [tokens.assistant.conversations.columns.question]: 'Question',
  [tokens.assistant.conversations.columns.response]: 'Response',
  [tokens.assistant.conversations.columns.user]: 'User',
  [tokens.assistant.conversations.columns.email]: 'Email',
  [tokens.assistant.conversations.columns.date]: 'Date',
  [tokens.assistant.conversations.columns.extractions]: 'Extractions',
  [tokens.assistant.conversations.columns.actions]: 'Actions',
  [tokens.assistant.conversations.columns.source]: 'Version',
  [tokens.assistant.conversations.filters.searchPlaceholder]: 'Search by message or email...',
  [tokens.assistant.conversations.filters.startDate]: 'Start date',
  [tokens.assistant.conversations.filters.endDate]: 'End date',
  [tokens.assistant.conversations.filters.dateRange]: 'Date range',
  [tokens.assistant.conversations.filters.extractionType]: 'Extraction type',
  [tokens.assistant.conversations.filters.allExtractions]: 'All extractions',
  [tokens.assistant.conversations.filters.emailPlaceholder]: 'Filter by email',
  [tokens.assistant.conversations.filters.source]: 'Source',
  [tokens.assistant.conversations.filters.allSources]: 'All',
  [tokens.assistant.conversations.filters.production]: 'Published',
  [tokens.assistant.conversations.filters.preview]: 'Preview',
  [tokens.assistant.conversations.filters.clear]: 'Clear filters',
  [tokens.assistant.conversations.pagination.showing]: 'Showing {{from}} to {{to}} of {{total}} conversations',
  [tokens.assistant.conversations.pagination.rowsPerPage]: 'Rows per page',
  [tokens.assistant.conversations.pagination.page]: 'Page {{current}} of {{total}}',
  [tokens.assistant.conversations.pagination.firstPage]: 'First page',
  [tokens.assistant.conversations.pagination.previousPage]: 'Previous page',
  [tokens.assistant.conversations.pagination.nextPage]: 'Next page',
  [tokens.assistant.conversations.pagination.lastPage]: 'Last page',
  [tokens.assistant.conversations.detail.title]: 'Conversation Details',
  [tokens.assistant.conversations.detail.messagesTab]: 'Messages',
  [tokens.assistant.conversations.detail.extractionsTab]: 'Extractions',
  [tokens.assistant.conversations.detail.extractionsCount]: 'extractions',
  [tokens.assistant.conversations.detail.noExtractions]: 'No extractions in this conversation',
  [tokens.assistant.conversations.detail.userLabel]: 'User',
  [tokens.assistant.conversations.detail.assistantLabel]: 'Assistant',
  [tokens.assistant.conversations.detail.extractionLabel]: 'Extraction',
  [tokens.assistant.conversations.detail.fieldsLabel]: 'fields',
  [tokens.assistant.conversations.detail.confidence]: 'Confidence',
  [tokens.assistant.conversations.export_csv.date]: 'Date',
  [tokens.assistant.conversations.export_csv.user]: 'User',
  [tokens.assistant.conversations.export_csv.email]: 'Email',
  [tokens.assistant.conversations.export_csv.question]: 'Question',
  [tokens.assistant.conversations.export_csv.response]: 'Response',
  [tokens.assistant.conversations.export_csv.extractions]: 'Extractions',
  [tokens.assistant.conversations.export_csv.answered]: 'Answered',
  [tokens.assistant.conversations.export_csv.conversationId]: 'Conversation ID',
  [tokens.ui.actions.close]: 'Close',
  [tokens.ui.actions.download]: 'Download',
};

export default translations;
